// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Assets/fonts/RobotoSerif-VariableFont_GRAD,opsz,wdth,wght.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./Assets/fonts/NunitoSans-VariableFont_YTLC,opsz,wdth,wght.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./Assets/fonts/GeneralSans-Variable.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./Assets/fonts/Lato-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./Assets/LandingPage/LandingPageBg1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./Assets/LandingPage/Topbgmobile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./Assets/LandingPage/Gscmlandingpage.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./Assets/LandingPage/Topbggscmmobile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./Assets/LandingPage/headerBg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./Assets/LandingPage/scholarBg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./Assets/LandingPage/Frame-PartnerUniversities.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./Assets/LandingPage/GreenGeomentricline.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./Assets/LandingPage/partnerBg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./Assets/LandingPage/whitelinebg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./Assets/LandingPage/Placement-dem.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./Assets/LandingPage/contactBg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("./Assets/LandingPage/ApplicationProcess.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("./Assets/LandingPage/ApplicationProcessmobilebg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml;utf8,<svg fill=\"rgba%28116,116,116,1%29\" height=\"30\" viewBox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 10l5 5 5-5z\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Roboto';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: 'Nunito';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@font-face {
  font-family: 'General Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@font-face {
  font-family: "Lato";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.App {
  height: 100vh;
  background-color: #fafbfc;
  box-sizing: border-box;
}

button {
  font-family: 'Nunito', sans-serif;
}

body {
  font-family: 'Roboto', serif;
}

.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* landing page css */
.landing-page-bg {
  background-color: #fcfcfc !important;
}
.landing-page {
  font-family: 'Roboto', serif;
  color: #000;
}

.top-section {
  position: relative;
  height: fit-content;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.top-overlay {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: 60px 120px 80px 100px;
}

.logo-section {
  position: absolute;
  top: 20px;
  left: 40px;
}

.iim-logo {
  width: 220px;
}

@media (max-width: 600px) {
  .iim-logo {
    width: 100px;
  }
}

@media (max-width: 600px) {
  .iim-logo {
    width: 170px;
  }
}

.heading-section {
  max-width: 50%;
  color: #fff;
  display: flex;
  flex-direction: column;
}

.heading-section h1 {
  font-size: 42px;
  font-weight: bold;
}

.heading-section p {
  font-size: 16px;
  margin-top: 15px;
}
.top-overlaydem {
  /* padding: 60px 80px; */
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background-repeat: no-repeat;
}

.content-wrapperdem {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0rem;
}

.mobile-why-container {
  width: 100vw;
  overflow: hidden;
  overflow-x: auto;
  display: none;
}

.mobile-why-container-layout {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 12px;
}

.mobile-header {
  height: 120px;
  width: auto;
  object-fit: contain;
}

@media (max-width: 600px) {
  .why-header {
    display: none;
  }

  .mobile-why-container {
    display: block;
  }
}

.heading-textdem {
  position: relative;
  top: 0;
  left: 0;
  width: 95.5%;
  height: 90vh;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: contain;
  background-repeat: no-repeat;
  color: #fff;
  margin: 0;
}
@media (max-width: 600px) {
  body .heading-textdem {
    width: 98vw;
    height: 50vh;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding: 0.85rem !important;
  }
}

.heading-textgscm {
  position: relative;
  top: 0;
  left: 0;
  width: 95.5%;
  height: 90vh;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: contain;
  background-repeat: no-repeat;
  color: #fff;
  margin: 0;
}
@media (max-width: 600px) {
  .heading-textgscm {
    height: 500px;
    width: 95.5%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    padding: 0.85rem !important;
  }
}

.otherbtns-container {
  display: none;
}

.otherbtns-container-layout {
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 8px;
}

.test-and-webinar-row {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  flex-wrap: wrap;
  padding: 0px 80px 60px 80px;
  margin-top: -2rem;
}

.test-section {
  flex: 1 1 48%;
}

.enqiry-btn {
  background: #ffffff;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  border: none;
  border-radius: 8px;
  color: #722c4e;
  font-size: 12px;
  font-weight: 500;
}

.reg-btn {
  background: linear-gradient(270deg, #ffeb42 -495%, #47712b 104.5%);
  border: 1px solid #edf1ea;
  box-shadow: 0px 4px 8px 0px #aeaeae40;
  padding: 8px 12px;
  color: #edf1ea;
  font-size: 14px;
  border-radius: 8px;
  font-weight: 600;
  width: 110px;
}

.form-box {
  background: #fff5d0;
  padding: 20px;
  border-radius: 2px;
}

.form-box h3 {
  margin-bottom: 5px;
}

.form-box p {
  font-size: 14px;
  color: #333;
}

.form-box form input[type='email'],
.form-box form input[type='text'] {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.row {
  display: flex;
  gap: 10px;
}

.checkbox-row,
.consent-row {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  margin: 10px 0;
  font-size: 13px;
}

.captcha-row {
  display: flex;
  gap: 10px;
  align-items: center;
  margin: 10px 0;
}

.captcha-code {
  background: #e4e4e4;
  padding: 8px 15px;
  border-radius: 5px;
  font-weight: bold;
}

.reload-btn {
  border: none;
  background: none;
  font-size: 18px;
  cursor: pointer;
}

.register-btn {
  width: 100%;
  padding: 10px;
  background: #79a64a;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-weight: bold;
  margin-top: 10px;
}

.signin-row {
  text-align: center;
  margin-top: 10px;
  font-size: 14px;
}

.green-section {
  background-size: cover;
  background-position: center;
  padding: 50px 20px;
  color: #fff;
  background-color: #568e46;
  text-align: center;
}

.green-section h2 {
  font-size: 32px;
  margin-bottom: 15px;
}

.green-section p {
  font-size: 18px;
  margin-bottom: 10px;
}

.sub-text {
  font-size: 14px;
  margin-top: 10px;
}

.inquiry-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.inquiry-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.inquiry-text-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.inquiry-title {
  color: #061938;
  font-size: 24px;
  font-weight: 500;
  margin: 0;
}

.inquiry-subtitle {
  color: #000000;
  font-size: 12px;
  font-weight: 400;
  margin: 0;
}

.inquiry-form-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.inquiry-consent {
  border: 1px solid #ebebeb;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 12px;
  border-radius: 6px;
  width: fit-content;
}

.consent-label {
  font-size: 12px;
  font-weight: 400;
  margin: 0;
}

.submit-button {
  background: #47712b;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  border: none;
  padding: 8px 0;
  width: 100%;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: start;
  width: 100%;
}

.address-field {
  display: flex;
  gap: 10px;
  width: 100%;
}
.input-field option[disabled] {
  color: #999;
}
.placeholder-grey {
  color: #999;
}

.check-intr {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 10px 0px;
  width: 100%;
}

.action-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  width: 100%;
}

.input-field {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  background-color: #fcfcfc;
  box-sizing: border-box;
  height: 40px;
  margin-bottom: 6px;
}
.scale-150 .input-field {
  height: 30px;
}
.input-field::placeholder {
  color: #757575 !important;
  opacity: 1;
}
.intr-stu {
  color: #585a64;
  font-size: 14px;
  font-weight: 500;
}

.captcha-conatiner {
  display: flex;
  align-items: start;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding-top: 10px;
}

.register-button {
  margin-top: 10px;
  width: 100%;
  background: linear-gradient(270deg, #ffeb42 -495%, #47712b 104.5%);
  color: white;
  padding: 14px;
  font-size: 16px;
  font-weight: bold;
  border: none;
  /* border-radius: 4px; */
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.scale-150 .register-button {
  margin-top: 0px;
  padding: 10px;
  font-size: 14px;
}
.header-heading {
  font-size: 66px;
  font-weight: 600;
  /* text-transform: capitalize !important; */
  text-align: start;
  padding-top: 90px;
  font-family: 'Roboto Serif', serif !important;
}
.header-heading-dem {
  font-size: 46px;
  font-weight: 600;
  /* text-transform: capitalize !important; */
  text-align: start;
  padding-top: 90px;
  font-family: 'Roboto Serif', serif !important;
  width: 100%;
}
@media (max-width: 1400px) {
  .top-overlay {
    padding: 60px 40px 70px 40px;
  }

  .header-heading {
    font-size: 46px;
    padding-top: 90px;
    padding-top: 65px !important;
  }
}
@media (min-width: 1900px) {
  .header-heading {
    padding-top: 60%;
  }
}

.nunito-sans-scope {
  font-family: 'Nunito', sans-serif;
}

.nunito-sans-scope * {
  font-family: 'Nunito', sans-serif;
}

.roboto-serif {
  font-family: 'Roboto Serif', serif !important;
}

.sub-heading {
  text-align: start !important;
  font-size: 20px;
  font-weight: 600;
  max-width: 50%;
  font-family: 'Nunito', sans-serif;
}

.d-flex-space-between {
  display: flex;
  /* justify-content: space-between; */
  align-items: start;
  /* gap: 30px; */
  text-align: start;
  flex-direction: column;
}

.d-flex-space-between p {
  font-size: 24px;
  font-weight: 600;
  color: #fff;
}

.d-flex-space-between h6 {
  font-size: 20px;
  font-weight: 400;
  /* font-style: italic; */
  color: #fff;
}

.right-form {
  width: 30%;
  padding-top: 30px;
  margin: 100px 0px;
  background: linear-gradient(rgb(255, 255, 255) 0%, rgb(255, 249, 196) 100%);
  padding: 35px;
  box-shadow: rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  text-align: start;
  box-sizing: border-box;
}

@media (max-width: 900px) {
  .right-form {
    width: 100%;
    margin: 0px;
    padding: 20px;
  }
  .heading-section {
    max-width: max-content;
  }
}

.right-form-dem {
  width: 35%;
  padding-top: 30px;
  /* margin: 100px 0px; */
  background: linear-gradient(rgb(255, 255, 255) 0%, rgb(255, 249, 196) 100%);
  padding: 35px;
  box-shadow: rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  text-align: start;
  box-sizing: border-box;
}

@media (max-width: 900px) {
  .right-form-dem {
    width: 100%;
    margin: 0px;
    padding: 20px;
  }
}
.right-form1 {
  width: 45%;
  margin: 200px 0px;
  padding-right: 35px;
  padding-left: 0;
  display: flex;
  flex-direction: column;
  text-align: start;
}

.font-family-robotoserif {
  font-family: 'Roboto Serif', serif !important;
}

.iti {
  width: 100% !important;
  margin-bottom: 14px !important;
}

.d-flex-justify-content-center {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.margin-top-30px {
  margin-top: 30px;
}

.programs-container {
  background-color: #f9f9f9;
  padding: 0 5% 5%;
}

.programs-heading {
  font-size: 38px;
  font-weight: 700;
  font-family: 'Roboto Serif', serif !important;
  color: #585a64;
}

.programs-list {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.program-card {
  display: flex;
  /* background: #fff url(./Assets/LandingPage/programcardbg.png) no-repeat right bottom; */
  background-size: contain;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
  width: 100%;
  box-shadow:
    0px 0px 1.41px rgba(0, 0, 0, 0.04),
    0px 0px 2.81px rgba(0, 0, 0, 0.06),
    0px 5.62px 11.24px rgba(0, 0, 0, 0.04);
  border-left: 5px solid transparent;
  background: white;
}

.program-content,
.program-content-testdate {
  padding: 30px 40px 30px 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
    gap: 20px;
  width: 100%;
}

.text-cont,
.card-col-det,
.card-btn-placement {
  flex: 1 1;
  min-width: 240px;
  display: flex;
  flex-direction: column;
  gap: 36px;
}
.scale-150 .text-cont,
.card-col-det,
.card-btn-placement {
  flex: 1 1;
  min-width: 210px;
  display: flex;
  flex-direction: column;
  gap: 36px;
}

.text-cont {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.text-cont-testdate {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 28px;
}

.program-title {
  color: rgba(114, 44, 78, 1);
  font-size: 1.75rem;
  font-weight: 700;
  font-family: 'Roboto Serif', serif !important;
}
.scale-150 .program-title{
  font-size: 1.5rem;
}

.scale-150 .program-subtitle{
  font-size: 0.875rem;
}

.program-subtitle {
  font-size: 1rem;
  color: rgba(114, 44, 78, 1);
  line-height: 1.5;
  max-width: 300px;
  padding-top: 1rem;
}

.vertical-line {
  width: 1px;
  background-color: rgba(229, 230, 234, 1);
  align-self: stretch;
}

.card-cont-det {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.programoffer-heading {
  color: rgba(117, 117, 117, 1);
  font-size: 1rem;
  font-weight: 400;
  margin: 0;
}

.programoffer-date {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-family: 'Roboto Serif', serif !important;
  font-size: 1.125rem;
}

.scale-150 .programoffer-date {
  font-size: 1rem;
}

.scale-150 .eligibility-text {
  font-size: 1rem;
}

.scale-150 .scholar-text-var2 {
  font-size: 1rem;
}

.scale-150 .scholar-text-var1 {
  font-size: 1.25rem;
}

.scale-150 .scholar-text-var3 {
  font-size: 1.25rem;
}
.eligibility-text {
  font-size: 1.125rem;
  font-weight: 600;
  color: #373a45;
  font-family: 'Roboto Serif', serif !important;
  margin: 0;
}

.card-btn-placement {
  display: flex;
  justify-content: center;
  align-items: start;
}

.brochure-btn {
  background-color: #3c8031;
  color: white;
  padding: 10px 20px;
  font-weight: 600;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
}

.brochure-btn img {
  width: 16px;
  height: 16px;
}

.test-date-ribbon {
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(270deg, #ffeb42 -495%, #47712b 104.5%);
  color: white;
  padding: 14px 20px;
  font-weight: 600;
  font-size: 15px;
  clip-path: polygon(0 0, 92% 0, 100% 100%, 91% 100%, 0 100%);
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-family: 'Roboto Serif', serif !important;
}

.test-date-ribbon span {
  display: inline-block;
  transform: skew(20deg);
  font-family: 'Roboto Serif', serif !important;
}


@media (max-width: 600px) {
  .programs-heading {
    font-size: 20px;
    font-weight: 600;
    margin: 10px 0px;
  }
  .header-heading {
    font-size: 24px;
    max-width: 100%;
    padding-top: 65px !important;
  }
  .top-overlay {
    padding: 60px 20px 40px 20px;
  }
  .sub-heading {
    max-width: 80%;
  }
  .d-flex-space-between p {
    font-size: 14px;
    max-width: 70%;
  }
  .d-flex-space-between h6 {
    font-size: 12px;
    max-width: 96%;
    padding: 0px !important;
    margin: 0px !important;
  }
  .d-flex-space-between {
    display: flex;
        flex-direction: column;
        align-items: start;
        gap: 0px;
  }
  .card-cont-det {
    /* flex-direction: row; */
    gap: 4px;
  }
  .programoffer-date div {
    font-size: 12px;
  }
  .programoffer-heading {
    font-size: 12px;
  }
  .eligibility-text {
    font-size: 12px;
  }
  .card-col-det {
    gap: 12px;
    width: 100%;
  }
  .program-card {
    background: #fff;
  }
  .program-content {
    flex-direction: column;
    align-items: start;
    padding: 30px 20px;
  }
  .vertical-line {
    display: none;
  }
  .text-cont {
    width: 100%;
    gap: 8px;
  }
  .program-subtitle {
    width: 100%;
  }
  .card-btn-placement {
    justify-content: 'center';
    align-items: 'center';
    width: 100%;
    margin-top: 24px;
  }
  .brochure-btn {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .test-date-ribbon{
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(270deg, #ffeb42 -495%, #47712b 104.5%);
    color: white;
    padding: 14px 0px !important;
    font-weight: 600;
    font-size: 15px;
    clip-path: none !important;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    font-family: 'Roboto Serif', serif !important;
    width: 100%;
  }
 
}

.recuirters-container {
  background-color: #f9f9f9;
}

.spiderConatiner {
  background:  #f9f9f9;
  background-position: top;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  width: 100%;
  /* padding: 0px 80px; */
  box-sizing: border-box;
}

.scale-150 .spiderConatiner {
  /* padding: 35px !important; */
}

.plainbgConatiner {
  /* background: url(./Assets/LandingPage/Plainbg.png), #f9f9f9; */
  background-position: top;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  width: 100%;
  padding: 0px 85px 0px 40px;
  box-sizing: border-box;
}
.spiderConatiner1 {
  background-position: top;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  width: 100%;
  padding: 0px 80px;
  box-sizing: border-box;
}
.webinarContainer {
  display: grid;
  grid-template-columns: 4.5fr 7.5fr;
  column-gap: 100px;
  align-items: center;
}

.webinar-content-main {
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: start;
  width: 100%;
}

.webinar-header {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  font-size: 2.25rem;
  font-weight: 600;
  color: #373a45;
  padding: 15px 60px 15px 25px;
}
.scale-150 .webinar-header {
  font-size: 1.75rem ;
}
.mobilecard {
  background: #ffffff;
  height: 120px;
  width: 220px;
  box-shadow: 0px 4px 12px 0px #c1c1c140;
  gap: 12px;
  display: none;
  padding: 12px;
  box-sizing: border-box;
}

.card-container-web {
  display: block;
}

.mobilecard-main-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  align-items: start;
}

.mobilecard-main-layout h6 {
  color: #373a45;
  font-size: 12px;
  font-weight: 700;
  margin: 0px;
}

.mobilecard-main-layout p {
  font-size: 12px;
  margin: 0px;
  font-weight: 400;
  color: #8c8e94;
}

.mobilecard button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  width: 100%;
  padding: 6px 0px;
  font-size: 12px;
  font-weight: 500;
  color: #ffffff;
  background: #47712b;
}

.webinar-card {
  box-shadow: 0px 0px 12.2px 0px #f9f9f9;
  border: 1.23px solid #f1f1f1;
  background: #fff;
  border-radius: 10px;
  width: 100%;
  box-sizing: border-box;
  padding: 30px 36px;


  
}
.webinar-card1 {
  box-shadow: 0px 0px 12.2px 0px #f9f9f9;
  /* border: 1.23px solid #f1f1f1; */
  background: rgba(255, 253, 236, 1);
  border-radius: 10px;
  width: 100%;
  box-sizing: border-box;
  padding: 30px 36px;
  border: 15px solid;
  border-image: linear-gradient(270deg, #FFEB42 -495%, #47712B 104.5%) 1;
  

  
}

.webinar-card-grid {
  display: grid;
  grid-template-columns: 8fr 4fr;
  align-items: center;
}

.webinar-card-grid-II {
  display: grid;
  grid-template-columns: 8fr 2fr 2fr;
  align-items: center;
  column-gap: 10px;
}

.webinar-card-header {
  border-bottom: 1px solid #d3bec8;
  padding-bottom: 18px;
}

.webinar-card-content {
  border-bottom: 1px solid #f1f1f1;
  padding: 18px 0px;
}

.webinar-card-grid h6,
.webinar-card-grid-II h6 {
  color: #722c4e;
  font-size: 22px;
  font-weight: 600;
  margin: 0px;
}

.webinar-card-grid h5,
.webinar-card-grid-II h5 {
  color: #061938;
  font-size: 17px;
  font-weight: 600;
  margin: 0px;
}

.webinar-card-grid p,
.webinar-card-grid-II p {
  color: #444444;
  font-size: 14px;
  font-weight: 400;
  margin: 0px;
}

.btn-webinar {
  background: #49722e;
  padding: 10px 16px;
  color: #ffffff;
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  text-wrap: nowrap;
}

.btn-webinar img {
  height: 16px;
  width: auto;
  object-fit: contain;
}

@media (max-width: 1400px) {
  .programs-container {
    padding: 2.1875rem 4.5rem 2.1875rem 3rem;
  }
}

.life-vid-container {
  display: flex;
  flex-direction: column;
  width: 95%;
  margin: 60px 0px;
  justify-content: center;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
}

.life-vid {
  background: linear-gradient(270deg, #ffeb42 -495%, #47712b 104.5%);
  text-align: center;
  padding: 20px 0px;
  width: 75%;
}

.life-vid-head {
  font-size: 21px;
  font-weight: 600;
  color: #ffffff;
  margin: 0px;
  text-align: center;
  font-family: "Roboto Serif", serif;
}

.vid {
  width: 75%;
  height: 600px;
  object-fit: cover;
}

.scholarship-main-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.scholarship-container {
  display: flex;
  flex-direction: column;
  gap: 47px;
  width: 68%;
}

.sclr-header {
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: "Roboto Serif", serif;
}

.sclr-header h6 {
  color: #585a64;
  font-size: 48px;
  font-weight: 600;
  margin: 0px;
  font-family: "Roboto Serif", serif;
}

.sclr-header span {
  font-size: 20px;
  font-weight: 400;
  margin: 0px;
  font-family: "Roboto Serif", serif;
}

.sclr-header p {
  color: #8c8124;
  font-size: 24px;
  font-weight: 500;
  margin: 0px;
  font-family: "Roboto Serif", serif;
}

.scholar-grid {
  display: grid;
  grid-template-columns: 4fr 4fr 4fr;
}

.scholar-content {
  /* height: 300px; */
  padding: 40px 30px 80px 30px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: start;
  /* font-family: "Roboto", serif; */
}
.scale-150 .scholar-content{
  padding: 2rem;
}
.scholar-content-var1 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-position: right;
  background-repeat: no-repeat;
  background-size: cover;
  color: #fff;
  /* font-family: "Roboto", serif; */
}

.scholar-content-var2 {
  background: rgba(237, 241, 234, 1);
  color: #585a64;
  /* font-family: "Roboto", serif; */
}

.scholar-text-var1 {
  font-size: 24px;
  font-weight: 500;
  margin: 0px;
  font-family: "Roboto Serif", serif;
}

.scholar-text-var2 {
  font-size: 21px;
  font-weight: 600;
  margin: 0px;
  font-family: "Roboto Serif", serif;
}

.scholar-text-var3 {
  font-size: 20px;
  font-weight: 500;
  margin: 0px;
  /* font-family: "Roboto", serif; */
}

.partner-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
  padding: 0px 80px 30px 110px;
  display: flex;
  flex-direction: column;
  gap: 62px;
}
.partner-bg1 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  padding: 30px 80px;
  display: flex;
  flex-direction: column;
  gap: 62px;
}

.partner-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.partner-header {
  margin: 0px;
  font-size: 48px;
  color: #585a64;
  font-weight: 600;
}

.location-head {
  font-size: 36px;
  color:rgba(71, 113, 43, 1);
  font-weight: 600;
  margin: 0px;
  font-family: "Roboto Serif", serif;
}

.partners-content-container {
  display: grid;
  grid-template-columns: 6fr 3fr 3fr;
  gap: 40px;
}

.partner-schools-grid {
  display: grid;
  grid-template-columns: 6fr 6fr;
  gap: 12px;
}

.partner-schools-grid-flex {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.partner-schools-grid-flex-var1 {
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
}

.partner-school-card {
  /* box-shadow: 0px 0px 1.58px 0px #0000000a; */
  /* box-shadow: 0px 0px 3.17px 0px #0000000f; */
  /* box-shadow: 0px 6.34px 12.68px 0px #0000000a; */
  /* background: #ffffff; */
  padding: 18px 26px;
  height: auto;
  box-sizing: border-box;
  width: 100%;
  /* border: 1px solid rgba(198, 211, 189, 1); */
}

.partner-school-card-container {
  display: flex;
  flex-direction: column;
  gap: 18px;
  align-items: start;
}

.partner-school-card-container img {
  height: 55px;
  width: auto;
  object-fit: contain;
}

.partner-school-card-container p {
  font-size: 18px;
  font-weight: 500;
  color: #505f79;
  text-decoration: underline;
  cursor: pointer;
}

.alumni-bg {
  background: linear-gradient(180deg, rgba(71, 113, 43, 0) 0%, rgba(71, 113, 43, 0.2) 253.83%);
  padding: 0px 100px 30px 100px;
  display: flex;
  flex-direction: column;
  gap: 60px;
}

.alumni-header-bg {
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.alumni-header-bg h6 {
  font-size: 48px;
  color: #585a64;
  font-weight: 600;
  margin: 0px;
  font-family: "Roboto Serif", serif;
}

.alumni-header-bg p {
  font-size: 24px;
  color: #505f79;
  font-weight: 400;
  margin: 0px;
}

.alumni-content-grid {
  display: grid;
  grid-template-columns: 6fr 6fr;
  gap: 60px;
  align-items: center;
}

.alumni-content-grid img {
  height: auto;
  width: 100%;
  object-fit: contain;
}

.countriesname {
  color: #505f79;
  font-size: 20px;
  font-weight: 400;
  margin: 10px 0px;
}

@media (max-width: 1300px) {
  .alumni-content-grid {
    grid-template-columns: 12fr;
    align-items: center;
  }
  .countriesname {
    font-size: 20px;
    font-family: "Roboto Serif", serif;
  }
}

@media (max-width: 600px) {
  .countriesname {
    font-size: 14px;
    margin: 0px;
    font-family: "Roboto Serif", serif;
  }
}

.countries-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  line-height: 1.6;
}

.countriesname {
  margin: 0;
  color: #666;
  font-size: 19px;
  white-space: nowrap;
}

.incubation-container-outer {
  /* background: linear-gradient(270deg, #ffeb42 -495%, #47712b 104.5%); */
  padding-top: 10px;
  margin: 80px 100px;
}

.picture-container-outer {
  padding-top: 10px;
  margin: 50px 0px;
}
.picture-container {
  display: grid;
  grid-template-columns: 5fr 7fr;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-position: top;
  background-repeat: no-repeat;
  background-size: cover;
  align-items: center;
}
.eligibility-container {
  display: grid;
  grid-template-columns: 5fr 7fr;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  background-position: top;
  background-repeat: no-repeat;
  background-size: cover;
  align-items: center;
}
.incubation-container {
  display: grid;
  grid-template-columns: 7fr 5fr;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-position: top;
  background-repeat: no-repeat;
  background-size: cover;
  align-items: center;
}
.placement-container {
  display: grid;
  grid-template-columns: 7fr 5fr;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-position: top;
  background-repeat: no-repeat;
  background-size: cover;
  align-items: center;
}
.incu-banner {
  /* height: 580px; */
  width: 100%;
  object-fit: cover;
}

.incu-layout {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0px 100px;
}
.picture-layout {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0px 24px 0px 52px;
}

.incu-layout h6 {
  color: #585a64;
  margin: 0px;
  font-size: 2.857rem;
  font-weight: 600;
  font-family: "Roboto Serif", serif;
}
.scale-150 .incu-layout h6{
  font-size: 2.25rem;
}
.scale-150 .incu-layout p{
  font-size: 1.25rem;
}
.incu-layout p {
  font-size: 1.5rem;
  font-weight: 400;
  color: #505f79;
  margin: 0px;
}

.contact-container {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  margin: 80px 100px;
  background-position: top;
  background-repeat: no-repeat;
  background-size: cover;
  display: grid;
  grid-template-columns: 6fr 6fr;
  align-items: end;
}

.contact-bg {
  background: #0000008f;
  padding: 240px 20px 80px 80px;
  display: flex;
  flex-direction: column;
  gap: 50px;
  box-sizing: border-box;
}

.contact-cell-container {
  display: flex;
  align-items: center;
  gap: 2.5rem;
}

.contact-cell-container img {
  border-radius: 50px;
  height: 46px;
  width: 46px;
  object-fit: contain;
  padding: 1.25rem;
  background: #fffdec;
}

.contact-dets-container {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.contact-dets-container h6 {
  color: #ffffff;
  font-size: 1.5rem;
  font-weight: 400;
  margin: 0px;
}
.scale-150 .contact-dets-container h6 {
  font-size: 1.25rem ;
}
.scale-150 .contact-dets-container h5 {
  font-size: 1.5rem;
}
.contact-dets-container h5 {
  color: #ffffff;
  font-size: 1.75rem;
  font-weight: 700;
  margin: 0px;
  font-family: "Roboto", serif;
}

.contact-banner-cont {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 0.75rem;
  padding: 0rem 1.25rem 3.75rem 5rem;
}
.scale-150 .contact-banner-cont h6 {
  font-size: 2.25rem;
}
.scale-150 .contact-banner-cont p {
  font-size: 1.25rem;
}
.scale-150 .contact-banner-cont {
  padding: 0rem 1.25rem 3.75rem 2.5rem;
}

.contact-banner-cont p {
  color: #ffffff;
  font-size: 1.375rem;
  font-weight: 500;
  margin: 0px;
}

.contact-banner-cont h6 {
  color: #ffffff;
  font-size: 2.8125rem;
  font-weight: 600;
  margin: 0px;
  font-family: "Roboto", serif;
}

.footer-container {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-container img {
  height: 72px;
  width: auto;
  object-fit: contain;
  margin-top: 50px;
}

.show-banner {
  display: none;
}

.incu-banner-lan {
  object-fit: contain;
  width: 100%;
}

@media (max-width: 1400px) {
  .webinarContainer {
    grid-template-columns: 12fr;
    column-gap: 0px;
  }
  .spiderConatiner {
    /* padding: 0px 60px 0px 60px; */
  }
}

@media (max-width: 600px) {
  .spiderConatiner {
    padding: 0px !important;
  }
  .programs-container {
    padding: 0px 20px 30px;
  }
  .webinar-card-content {
    display: none;
  }
  .webinar-card-header {
    display: none;
  }
  .webinar-card {
    background: none;
    padding: 0px;
    display: flex;
    align-items: start;
  }
  .spiderConatiner {
    /* padding: 0px 20px; */
  }
  .life-vid {
    width: 100%;
    padding: 5px 0px;
  }
  .vid {
    width: 100%;
    height: 30%;
  }
  .life-vid-head {
    font-size: 12px;
  }
  .scholar-grid {
    grid-template-columns: 12fr;
  }
  .scholarship-container {
    width: 100%;
  }
  .scholar-text-var2 {
    font-size: 16px;
  }
  .scholar-text-var3 {
    font-size: 18px;
  }
  .scholar-text-var1 {
    font-size: 18px !important;    
  }
  .scholar-content {
    padding: 30px 20px;
    height: fit-content !important;
        justify-content: start;
  }
  .alumni-bg {
    padding: 20px;
  }
  .incubation-container {
    grid-template-columns: 12fr;
  }
  .eligibility-container {
    grid-template-columns: 12fr;
  }
  .show-banner {
    display: block !important;
  }
  .incubation-container-outer {
    margin: 80px 20px;
  }
  .incu-banner {
    display: none;
  }
  .incu-banner-lan {
    display: none;
    /* height: 250px; */
  }
  .incu-banner-lan {
    display: none;
    /* height: 250px; */
  }
  .picture-container-outer {
    margin: 80px 20px;
  }
  .picture-layout {
    padding: 16px;
  }
  .incu-layout {
    padding: 16px;
  }
  .contact-container {
    margin: 80px 20px;
    grid-template-columns: 12fr;
  }
  .contact-dets-container h6 {
    font-size: 12px;
  }
  .contact-dets-container h5 {
    font-size: 15px;
  }
  .contact-cell-container img {
    height: 26px;
    padding: 12px;
    width: 26px;
  }
  .contact-banner-cont {
    padding: 120px 0px 40px 20px;
  }
  .contact-bg {
    gap: 20px;
    padding: 40px 8px;
  }
  .contact-banner-cont p {
    font-size: 12px;
  }
  .contact-banner-cont h6 {
    font-size: 24px;
    font-family: "Roboto", serif;
  }
  .partner-bg {
    padding: 20px;
  }
  .partner-container {
    gap: 12px;
    overflow: hidden;
    overflow-x: auto;
  }
  .partner-container::-webkit-scrollbar {
    display: none;
  }
  .partner-schools-grid {
    display: flex;
    gap: 12px;
    flex-direction: column;
  }
  .partner-schools-grid-flex {
    flex-direction: column;
    gap: 20px;
  }
  .partner-schools-grid-flex-var1 {
    gap: 16px;
  }
  .partners-content-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .location-head {
    font-size: 20px;
    font-family: "Roboto Serif", serif;
    color:'rgba(71, 113, 43, 1)'
  }
  .partner-school-card {
    height: auto;
    padding: 10px 16px !important;
  }
  .partner-school-card-container p {
    text-wrap: nowrap;
  }
  .webinar-content-main {
    gap: 8px;
  }
  .webinar-header {
    font-size: 24px;
    font-weight: 500;
  }
  .webinarContainer {
    row-gap: 24px;
  }
  .sclr-header h6 {
    font-size: 20px;
  }
  .sclr-header span {
    font-size: 10px;
  }
  .sclr-header p {
    font-size: 14px;
  }
  .sclr-header {
    gap: 12px;
  }
  .partner-bg {
    gap: 24px;
    padding-top: 0px;
    background: #ffffff;
  }
  .alumni-header-bg h6 {
    font-size: 20px;
    font-family: "Roboto Serif", serif;
  }
  .alumni-header-bg p {
    font-size: 14px;
  }
  .alumni-bg {
    gap: 16px;
    background: #fff;
  }
  .incu-layout h6 {
    font-size: 20px;
    font-family: "Roboto Serif", serif;
  }
  .incu-layout p {
    font-size: 14px;
  }
  .incu-layout {
    gap: 12px;
  }
  .incubation-container-outer {
    margin: 20px;
  }
  .full-width-scroll {
    width: 100vw;
    overflow: scroll;
  }
  .card-container-web {
    display: flex;
    align-items: start;
    width: max-content;
    gap: 12px;
  }
  .mobilecard {
    display: flex;
    flex-direction: column;
  }
  .otherbtns-container {
    display: flex;
    align-items: start;
    justify-content: space-between;
  }
}

.appprocess-container {
  width: 100%;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) no-repeat center center;
  background-size: cover;
}
@media (max-width: 768px) {
  .appprocess-container {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) no-repeat center center;
    background-size: cover;
  }
}
.appprocess-overlay {
  display: flex;
  width: 100%;
  min-height: 400px;
}

.appprocess-left,
.appprocess-right {
  flex: 1 1;
}

.appprocess-left {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 40px;
  padding-bottom: 20px;
}

.appprocess-heading {
  font-size: 32px;
  font-weight: bold;
  color: white;
  font-family: 'Roboto Serif', serif !important;
}

.appprocess-right {
  background-color: rgba(0, 0, 0, 0.56);
  display: flex;
  /* align-items: center; */
}

.appprocess-steps {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 40px;
  color: white;
}

.step {
  display: flex;
  align-items: center;
  font-size: 22px;
  font-family: 'Roboto Serif', serif !important;
}

.step-icon {
  color: #3ad447;
  font-size: 24px;
  margin-right: 10px;
}

.address {
  font-size: 1rem;
  color: #47712b;
  font-weight: 400;
  max-width: 20.75rem;
  margin: 2.75rem 0rem 2.5rem 0rem;  
  text-align: center;
}

.scale-150 .address {
  font-size: 1rem;
  max-width: 21.875rem;
  margin: 2.1875rem 0;  
}

.divider {
  height: 1.4px;
  background: #5a4a95;
  width: 85%;
}

.about-program-container {
  /* max-width: 1200px;
  margin: 0 auto; */
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  align-items: center;
  /* justify-content: space-between; */
  justify-content: space-around;
}

.about-program-text {
  flex: 1 1;
  min-width: 300px;
  color: white;
}

.about-title {
  font-size: 3.5rem;
  margin-bottom: 2.5rem;
  color: white;
}
.scale-150 .about-title{
  font-size: 3rem;
  margin-bottom: 2rem;
}
.scale-150 .content{
  font-size: 1rem;
}
.scale-150 .content-dem{
  font-size: 1.5rem;
}
.scale-150 .bullet{
  font-size: 0.75rem;
}
.about-list {
  list-style: none;
  padding: 0;
  margin: 0;
  color: white;
}

.about-item {
  display: flex;
  align-items: first baseline;
  margin-bottom: 1rem;
  color: white;
}

.bullet {
  font-weight: bold;
  margin-right: 10px;
  line-height: 1;
  font-size: 1rem;
}

.content {
  font-size: 1.25rem;
  line-height: 1.5;
}
.content-dem{
  font-size: 2rem;
  line-height: 1.5;
}
.about-program-image-wrapper {
  flex: 1 1;
  min-width: 300px;
  display: flex;
  justify-content: center;
}

.about-program-image-card {
  transform: translateY(50px);
}

.about-program-image-card img {
  width: 100%;
  height: auto;
}
.about-program-image-wrapper {
  flex: 1 1;
  min-width: 300px;
  display: flex;
  justify-content: center;
  position: relative;
}
.about-program-image-card .main-image {
  width: 80%;
  height: 90%;
  border-radius: 6px;
  display: block;
}

.about-program-image-card .overlay-image {
  position: absolute;
  bottom: 10%;
  left: 30%;
  transform: translateX(-50%);
  width: 100%;
}

.containerprogram {
  display: flex;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  align-items: center;
}

.left img {
  max-width: 100%;
  height: auto;
  display: block;
}

.right {
  padding-left: 2rem;
}

.key-elements-container {
  /* padding: 3rem 0rem; */
  text-align: center;
  background: linear-gradient(to right, #f9f9f9 85%, transparent 50%);
}

.key-elements-heading {
  font-size: 2rem;
  color: #444;
  margin-bottom: 2rem;
}

.key-elements-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
}
@media (max-width: 768px) {
  .key-elements-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.key-element-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  text-align: center;
  min-height: 160px;
  position: relative;
}

.key-element-card:not(:nth-child(6n))::after {
  content: '';
  position: absolute;
  top: 15%;
  right: 0;
  height: 70%;
  width: 1px;
  background: linear-gradient(to bottom, rgba(63, 107, 63, 0.1), rgba(63, 107, 63, 0.5));
}

.key-element-card:not(:nth-last-child(-n + 6))::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 15%;
  width: 70%;
  height: 1px;
  background: linear-gradient(to right, rgba(63, 107, 63, 0.1), rgba(63, 107, 63, 0.5));
}

.key-element-card:nth-last-child(-n + 6) {
  border-bottom: 2px solid #3f6b3f;
}

.key-element-icon {
  width: 50px;
  height: 50px;
  margin-bottom: 0.8rem;
}

.key-element-title {
  font-size: 20px;
  color: #333;
  max-width: 230px;
}
.program-structure {
  padding: 0rem 5.5rem 0rem 2rem;
  text-align: center;
}

.heading {
  font-size: 2.5rem;
  font-weight: 600;
  color: #2d2d2d;
  margin-bottom: 2.5rem;
}

.cards-row {
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  /* overflow-x: auto; */
}

.card {
  flex: 1 1;
  min-width: 200px;
  max-width: 285px;
  padding: 1.5rem;
  text-align: left;
  box-sizing: border-box;
}

.card-green {
  background-color: #f1f5f0;
}

.card-white {
  background-color: #ffffff;
}

.card-border {
  position: relative;
}

.card-border::after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 2px;
  height: 30px;
  background-color: #6e5ba4;
}

.card-number {
  font-weight: 500;
  font-size: 1rem;
  color: rgba(88, 90, 100, 1);
  margin-bottom: 0.4rem;
  display: inline-block;
}

.card-title {
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 0.4rem;
  color: rgba(42, 42, 42, 1);

}

.card-description {
  font-size: 1rem;
  color: rgba(80, 95, 121, 1);
  font-family: 'Nunito' !important;
}

.placement-heading {
  font-size: 2.5rem;
  color: rgba(88, 90, 100, 1);
  font-weight: 600;
  margin-bottom: 2.5rem;
}

.placement-section {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.placement-custom-grid {
  display: flex;
  gap: 2rem;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 1200px;
  width: 100%;
}

/* .placement-box {
  padding: 1.5rem;
  color: #2d2d2d;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 160px;
} */

.placement-box h3 {
  margin: 0;
  font-size: 1.2rem;
}

.placement-box .big {
  font-size: 1.6rem;
  font-weight: bold;
  /* color: #0a5f30; */
}

.placement-box p {
  font-size: 0.9rem;
  margin-top: 0.5rem;
  
}

.green {
  background-color: #3f6b3f;
  color: #fff;
}

.yellow {
  background-color: #fff7ba;
  color: rgba(71, 113, 43, 1);
}

.lightgray {
  background-color: #f0f0f0;
  color: rgba(71, 113, 43, 1);
}

.image-box {
  height: 100%;
  overflow: hidden;
}

.image-box img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  display: block;
}

.placement-custom-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  /* padding: 0rem 4rem; */
}

.column {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  max-width: 300px;
  gap: 1rem;
  height: 400px;
}

.placement-box {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  /* padding-top: 5rem; */
}

.full-width {
  width: 100%;
}
.alumni-header-row1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
}

.alumni-header-row1 h6 {
  flex: 1 1;
  font-size: 1.5rem;
  margin: 0;
}

.alumni-header-row1 p {
  flex: 3 1;
  text-align: right;
  margin: 0;
}
.key-elements-container-gscm {
  /* padding: 3rem 2rem; */
  text-align: center;
  background: linear-gradient(to right, #f9f9f9 95%, transparent 50%);
}

.key-elements-grid-gscm {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}

.key-element-card-gscm {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 160px;
  position: relative;
}

.key-element-card-gscm:not(:nth-child(4n))::after {
  content: '';
  position: absolute;
  top: 15%;
  right: 0;
  height: 70%;
  width: 1px;
  background: linear-gradient(to bottom, rgba(63, 107, 63, 0.1), rgba(63, 107, 63, 0.5));
}

.key-element-card-gscm:not(:nth-last-child(-n + 4))::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 15%;
  width: 70%;
  height: 1px;
  background: linear-gradient(to right, rgba(63, 107, 63, 0.1), rgba(63, 107, 63, 0.5));
}

.key-element-card-gscm:nth-last-child(-n + 4) {
  border-bottom: 2px solid #3f6b3f;
}

.webinar-mobile-scroll {
  display: none;
}

@media screen and (max-width: 768px) {
  .webinar-mobile-scroll {
    display: flex;
    overflow-x: auto;
    gap: 1rem;
    padding: 1rem 0;
    scroll-snap-type: x mandatory;
  }

  .webinar-mobile-card {
    min-width: 80%;
    flex: 0 0 auto;
    background-color: white;
    border-radius: 8px;
    padding: 1.5rem;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    scroll-snap-align: start;
  }

  .program-title {
    font-weight: 700;
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    color: rgba(114, 44, 78, 1) !important;
    
  }

  .date-label {
    color: #999;
    margin-bottom: 1rem;
  }

  .date-value {
    color: #f46f5e;
    font-weight: 600;
  }

  .register-btn {
    background-color: #476d24;
    color: white;
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: 4px;
    font-size: 1rem;
    cursor: pointer;
  }

  .webinar-desktop-card {
    display: none;
  }
  .appprocess-steps {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 1rem;
    color: white;
  }
  .address {
    font-size: 14px;
    color: #47712b;
    font-weight: 400;
    max-width: 300px;
    margin: 60px 0px 40px 0px;
    text-align: center;
  }
  
}

/* CustomDatePicker.css */
/* .react-datepicker {
  border: none;
  font-family: 'Nunito Sans', sans-serif;
  padding: 1rem;
  width: 100%;
  max-width: 300px;
} */

.react-datepicker__header {
  background: none !important;
  border-bottom: none !important;
  padding-bottom: 0.5rem;
}

.react-datepicker__current-month {
  font-weight: 600;
  font-size: 1rem;
  color: #2e2e2e;
}

.react-datepicker__day-names {
  margin-top: 0.5rem;
  display: flex;
  justify-content: space-between;
  font-weight: 500;
  color: #777;
}

.react-datepicker__week {
  display: flex;
  justify-content: space-between;
  margin: 0.2rem 0;
}

.react-datepicker__day {
  border-radius: 6px;
  width: 36px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  margin: 0;
  cursor: pointer;
  font-weight: 500;
  color: #2e2e2e;
}

.react-datepicker__day--selected,
.react-datepicker__day--keyboard-selected {
  background-color: #4b8a2e;
  color: white;
}

.react-datepicker__day--disabled {
  color: #ccc;
  cursor: not-allowed;
}

.react-datepicker__triangle {
  display: none;
}

/* Green for allowed dates */
.allowed-green-day {
  background-color: #d4edda !important;
  color: #256029 !important;
  border-radius: 6px;
}

/* Red for selected date */
.selected-red-day {
  background-color: #f8d7da !important;
  color: #721c24 !important;
  border-radius: 6px;
}

.custom-checkbox {
  position: relative;
  appearance: none;
  width: 16px;
  height: 16px;
  border: 2px solid #ccc;
  border-radius: 3px;
  cursor: pointer;
}

.custom-checkbox:checked {
  background-color: rgba(181, 167, 47, 1);
  border-color: rgba(181, 167, 47, 1);
}

.custom-checkbox:checked::after {
  content: '✔';
  position: absolute;
  top: -1px;
  left: 1px;
  color: white;
  font-size: 12px;
}

/* Make the datepicker calendar full width */
.react-datepicker {
  padding: 10px 15px;
  width: 100% !important;
  border: none !important;
  border-radius: 10px !important;
  box-shadow: 0px 0px 15px 0px rgba(96, 71, 151, 0.1);
  height: 100% !important;
  width: 95% !important;
}

/* Optional: make the month grid full width */
.react-datepicker__month-container {
  width: 100%;
}

/* Optional: adjust day cell sizing if you want better spacing */
.react-datepicker__day {
  width: 100% !important;
  max-width: 100%;
  text-align: center;
}

/* Hide dates from other months */
.hide-outside-dates {
  visibility: hidden;
  pointer-events: none;
}

/* Keep your custom styles */
.custom-allowed-day {
  background-color: rgba(237, 241, 234, 1) !important;
  color: #000;
  border-radius: 6px;
}

.custom-today-day {
  background-color: rgba(237, 241, 234, 1) !important;
  border: 1px solid rgba(108, 141, 85, 1) !important;
  color: #000;
  border-radius: 6px;
}

.custom-selected-day {
  background: linear-gradient(270deg, #ffeb42 -495%, #47712b 104.5%) !important;
  color: white !important;
  border-radius: 6px;
}

.webinar-banner {
  margin-bottom: 70px;
  background-size: cover;
  background-position: center;
  width: 100%;
  min-height: 433px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 40px 20px;
  position: relative;
}

.webinar-content {
  padding-left: 22%;
  max-width: 600px;
  width: 100%;
  border-radius: 8px;

}
.scale-150 .webinar-content{
  padding-left: 30%;
}

.webinar-label {
  color: #47712b;
  font-weight: bold;
  font-size: 1.1rem;
  margin-bottom: 10px;
}

.webinar-title {
  font-size: 3rem;
  font-weight: 700;
  color: #1b1b1b;
  margin: 5px 0;
}
.scale-150 .webinar-title{
  font-size: 2.25rem;
}
.scale-150 .webinar-subtext {
  font-size: 1rem !important;
  margin-top: 0;
}
.webinar-subtext {
  border-radius: 6px;
  /* padding: 6px 14px; */
  margin-top: 30px;
  font-style: italic;
  font-size: 1.1rem;
  color: #333;
  display: flex;
  align-items: center;
  /* background-color: rgba(237, 241, 234, 1); */
  max-width: 100%;
  width: fit-content;
  font-family: 'Nunito, sans-serif';
}

.dot-icon {
  color: #c53030;
  font-weight: bold;
  margin-right: 8px;
  font-size: 18px;
}

/* ✅ Responsive Breakpoints */
@media screen and (max-width: 768px) {
  .webinar-content {
    padding-left: 0;
    text-align: center;
    display: flex;
        flex-direction: column;
        align-items: center;
  }

  .webinar-title {
    font-size: 32px;
  }

  .webinar-subtext {
    justify-content: center;
    font-size: 0.95rem;
    padding: 0px !important;

  }

  .dot-icon {
    font-size: 16px;
  }
}

@media screen and (max-width: 480px) {
  .webinar-title {
    font-size: 24px;
  }

  .webinar-label {
    font-size: 1rem;
  }

  .webinar-subtext {
    font-size: 0.9rem;
    /* width: 100% !important; */
    margin-top: 0px !important;

  }
}
.slider-list {
  height: 100% !important;
}

.slider-container {
  height: 100% !important;
}
.input-error {
  border-color: red;
}

.error-text {
  color: red;
  font-size: 13.5px;
  margin-bottom: 4px;
}
select.select-custom:disabled {
  background-color: #f5f5f5 !important;
  opacity: unset !important;
  border: 1px solid #ccc;
  cursor: unset !important;
}
/* CSS */
.select-custom {
  appearance: none;
  -webkit-appearance: none; /* Safari */
  -moz-appearance: none; /* Firefox */
  background-color: #fcfcfc;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
  color: rgba(116, 116, 116, 1);
  border: 1px solid #ccc;
  height: 40px;
  border-radius: 6px;
  width: 100%;
  padding: 0px 12px;
  margin-bottom: 4.5px;
  cursor: pointer !important;
}
.scale-150 .select-custom {
  height: 30px;
}
.program-select-custom{
  appearance: none;
  -webkit-appearance: none; /* Safari */
  -moz-appearance: none; /* Firefox */
  background-color: #fcfcfc;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
  color: rgba(116, 116, 116, 1);
  border: 1px solid #ccc;
  height: 40px;
  border-radius: 6px;
  width: 100%;
  padding: 0px 12px;
  margin-bottom: 4.5px;
  cursor: pointer !important;
}
select.program-select-custom:disabled {
  background-color: #f5f5f5 !important;
  opacity: unset !important;
  border: 1px solid #ccc;
  cursor: unset !important;
}
.scale-150 .program-select-custom {
  height: 30px;
}

.alumni-wrapper {
  padding: 3.5rem;
  overflow: hidden;
  padding-bottom: 0;
}

.alumni-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.alumni-header h2 {
  font-size: 24px;
  font-weight: bold;
  font-family: 'Roboto', sans-serif;
  background: linear-gradient(90deg, #fffbcf, transparent);
  padding: 0.5rem 1rem;
}

.arrow-buttons button {
  margin-left: 8px;
  padding: 0px 13px;
  font-size: 31px;
  border: none;
  background-color: rgba(255, 249, 196, 1);
  cursor: pointer;
  color: rgba(107, 99, 28, 1);
}

.image-row {
  display: flex;
  gap: 2rem;
  margin-top: 1.5rem;
  height: 600px;
}

.image-sixty {
  width: 60%;
  height: 70%;
  object-fit: cover;
}

.image-forty {
  width: 40%;
  height: 70%;
  object-fit: cover;
}



@media (max-width: 768px) {
  .image-row {
    flex-direction: column;
    height: auto;
  }

  .image-sixty,
  .image-forty {
    width: 100%;
    height: 300px;
  }
}


/* Tablet screens (≤ 992px) and smaller */
@media screen and (max-width: 992px) {
  .partners-content-container {
    grid-template-columns: 1fr; 
    gap: 24px; 
  }
}

.card {
  transition: transform 0.1s ease;
  transform: scale(1.05);
  cursor: pointer;
  text-align: left;
}

.card:hover {
  transform: scale(1.03);
  background-color: rgba(198, 211, 189, 1);
}

.card-title,
.card-description {
  transition: font-size 0.1s ease;
}

.card:hover .card-title {
  font-size: 24px; /* 4px increase from default (e.g. 20px) */
}

.card:hover .card-description {
  font-size: 18px; /* 4px increase from default (e.g. 14px) */
}

.zoomed-out {
  font-size: 33.33%; /* all rem units inside will be scaled to 1/3 */
}

.duration-badge {
  background-color: #f2f6f1;
  color: #2c5e1a;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 14px;
}

.overlay-video {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
/* @media (min-resolution: 1.5dppx) {
  .form-wrapper {
    transform: scale(0.75);
    transform-origin: top right;
  }

  .form-wrapper-container {
    overflow: visible;
    width: fit-content;
  }
} */
@media (min-resolution: 1.2dppx) {
  .form-wrapper {
    transform: scale(0.85);
    transform-origin: top right;
  }

  .form-wrapper-container {
    overflow: visible;
    width: fit-content;
  }
}


@media (min-resolution: 1.79dppx) {
  .form-wrapper {
    transform: scale(1);
    transform-origin: unset;
  }

  .form-wrapper-container {
    width: 450px;
  }
}
.form-wrapper{
  font-family: 'Nunito', sans-serif;
}

@media (min-resolution: 1.2dppx) {
  .floating-panel {
    transform: scale(0.75);
    transform-origin: top right;
  }
}

.custom-textarea::placeholder {
  font-family: 'Nunito', sans-serif;
}

@media (min-resolution: 1.2dppx) {
  .application-card-wrapper {
    transform: scale(0.95);
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,4CAA+E;AACjF;;AAEA;EACE,qBAAqB;EACrB,4CAA8E;AAChF;;AAEA;EACE,2BAA2B;EAC3B,4CAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,4CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,8JAA8J;EAC9J,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,qBAAqB;AACrB;EACE,oCAAoC;AACtC;AACA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,yDAAgE;EAChE,wBAAwB;EACxB,4BAA4B;EAC5B,WAAW;EACX,SAAS;AACX;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,yDAA6D;IAC7D,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B;EAC7B;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,yDAAiE;EACjE,wBAAwB;EACxB,4BAA4B;EAC5B,WAAW;EACX,SAAS;AACX;AACA;EACE;IACE,aAAa;IACb,YAAY;IACZ,yDAAiE;IACjE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kEAAkE;EAClE,yBAAyB;EACzB,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kEAAkE;EAClE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,aAAa;EACb,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,iBAAiB;EACjB,iBAAiB;EACjB,6CAA6C;AAC/C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,iBAAiB;EACjB,iBAAiB;EACjB,6CAA6C;EAC7C,WAAW;AACb;AACA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,2EAA2E;EAC3E,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE;IACE,WAAW;IACX,WAAW;IACX,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,uBAAuB;EACvB,2EAA2E;EAC3E,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE;IACE,WAAW;IACX,WAAW;IACX,aAAa;EACf;AACF;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yFAAyF;EACzF,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX;;;0CAGwC;EACxC,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;;EAEE,4BAA4B;EAC5B,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;IACjB,SAAS;EACX,WAAW;AACb;;AAEA;;;EAGE,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;;;EAGE,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;AAC/C;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,6CAA6C;EAC7C,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,kEAAkE;EAClE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2DAA2D;EAC3D,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,6CAA6C;AAC/C;;;AAGA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,eAAe;IACf,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,eAAe;IACf,cAAc;IACd,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,aAAa;QACT,sBAAsB;QACtB,kBAAkB;QAClB,QAAQ;EACd;EACA;IACE,yBAAyB;IACzB,QAAQ;EACV;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,SAAS;IACT,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,QAAQ;EACV;EACA;IACE,WAAW;EACb;EACA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,kEAAkE;IAClE,YAAY;IACZ,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,6CAA6C;IAC7C,WAAW;EACb;;AAEF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gEAAgE;EAChE,wBAAwB;EACxB,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mDAAkD;EAClD,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,sCAAsC;EACtC,SAAS;EACT,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;;;;AAIpB;AACA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,kCAAkC;EAClC,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,sEAAsE;;;;AAIxE;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kEAAkE;EAClE,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,aAAa;AACf;AACA;EACE,mDAAmD;EACnD,0BAA0B;EAC1B,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,oDAAmE;EACnE,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,oDAA6D;EAC7D,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,8CAA8C;EAC9C,8CAA8C;EAC9C,kDAAkD;EAClD,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,4FAA4F;EAC5F,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,eAAe;IACf,WAAW;IACX,kCAAkC;EACpC;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,wEAAwE;EACxE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,oDAAmD;EACnD,wBAAwB;EACxB,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,oDAAqD;EACrD,wBAAwB;EACxB,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,oDAAmD;EACnD,wBAAwB;EACxB,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,oDAAuD;EACvD,wBAAwB;EACxB,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,oDAAmD;EACnD,kBAAkB;EAClB,wBAAwB;EACxB,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;AACpC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,oDAAmD;EACnD,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;IACE,2BAA2B;IAC3B,eAAe;EACjB;EACA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,kBAAkB;IAClB,8BAA8B;QAC1B,sBAAsB;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,2BAA2B;EAC7B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,SAAS;IACT,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,4BAA4B;EAC9B;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;IACT,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,SAAS;IACT,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,eAAe;IACf,kCAAkC;IAClC;EACF;EACA;IACE,YAAY;IACZ,6BAA6B;EAC/B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,QAAQ;EACV;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;IACT,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,kCAAkC;EACpC;EACA;IACE,eAAe;EACjB;EACA;IACE,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kCAAkC;EACpC;EACA;IACE,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,8BAA8B;EAChC;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4EAAsF;EACtF,sBAAsB;AACxB;AACA;EACE;IACE,4EAA8F;IAC9F,sBAAsB;EACxB;AACF;AACA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE;mBACiB;EACjB,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mEAAmE;AACrE;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;AACvC;AACA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,UAAU;EACV,sFAAsF;AACxF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,qFAAqF;AACvF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;;AAE5B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;;;;;;;GAOG;;AAEH;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;;AAEpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,gBAAgB;EAChB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mEAAmE;AACrE;;AAEA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,UAAU;EACV,sFAAsF;AACxF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,qFAAqF;AACvF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,cAAc;IACd,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,wCAAwC;IACxC,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,sCAAsC;;EAExC;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,YAAY;EACd;EACA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;EACpB;;AAEF;;AAEA,yBAAyB;AACzB;;;;;;GAMG;;AAEH;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,mDAAmD;EACnD,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA,6CAA6C;AAC7C;EACE,WAAW;AACb;;AAEA,gEAAgE;AAChE;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,4BAA4B;AAC5B;EACE,mDAAmD;EACnD,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mDAAmD;EACnD,kDAAkD;EAClD,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,6EAA6E;EAC7E,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;;AAEpB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8CAA8C;EAC9C,eAAe;EACf,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE;IACE,eAAe;IACf,kBAAkB;IAClB,aAAa;QACT,sBAAsB;QACtB,mBAAmB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;;EAEzB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,4BAA4B;IAC5B,0BAA0B;;EAE5B;AACF;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;AACA,QAAQ;AACR;EACE,gBAAgB;EAChB,wBAAwB,EAAE,WAAW;EACrC,qBAAqB,EAAE,YAAY;EACnC,yBAAyB;EACzB,0DAA+L;EAC/L,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,6BAA6B;EAC7B,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,wBAAwB,EAAE,WAAW;EACrC,qBAAqB,EAAE,YAAY;EACnC,yBAAyB;EACzB,0DAA+L;EAC/L,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,6BAA6B;EAC7B,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,0BAA0B;AAC5B;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,wDAAwD;EACxD,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,wCAAwC;EACxC,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;;;AAIA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,aAAa;EACf;AACF;;;AAGA,yCAAyC;AACzC;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,eAAe,EAAE,0CAA0C;AAC7D;;AAEA;EACE,eAAe,EAAE,0CAA0C;AAC7D;;AAEA;EACE,iBAAiB,EAAE,+CAA+C;AACpE;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;;;;;;;;;GAUG;AACH;EACE;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;;AAGA;EACE;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;AACF;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;AACF;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":["@font-face {\n  font-family: 'Roboto';\n  src: url('./Assets/fonts/RobotoSerif-VariableFont_GRAD\\,opsz\\,wdth\\,wght.woff');\n}\n\n@font-face {\n  font-family: 'Nunito';\n  src: url('./Assets/fonts/NunitoSans-VariableFont_YTLC\\,opsz\\,wdth\\,wght.woff');\n}\n\n@font-face {\n  font-family: 'General Sans';\n  src: url('./Assets/fonts/GeneralSans-Variable.woff2');\n}\n\n@font-face {\n  font-family: \"Lato\";\n  src: url('./Assets/fonts/Lato-Regular.woff2');\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.App {\n  height: 100vh;\n  background-color: #fafbfc;\n  box-sizing: border-box;\n}\n\nbutton {\n  font-family: 'Nunito', sans-serif;\n}\n\nbody {\n  font-family: 'Roboto', serif;\n}\n\n.hide-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* landing page css */\n.landing-page-bg {\n  background-color: #fcfcfc !important;\n}\n.landing-page {\n  font-family: 'Roboto', serif;\n  color: #000;\n}\n\n.top-section {\n  position: relative;\n  height: fit-content;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n}\n\n.top-overlay {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  padding: 60px 120px 80px 100px;\n}\n\n.logo-section {\n  position: absolute;\n  top: 20px;\n  left: 40px;\n}\n\n.iim-logo {\n  width: 220px;\n}\n\n@media (max-width: 600px) {\n  .iim-logo {\n    width: 100px;\n  }\n}\n\n@media (max-width: 600px) {\n  .iim-logo {\n    width: 170px;\n  }\n}\n\n.heading-section {\n  max-width: 50%;\n  color: #fff;\n  display: flex;\n  flex-direction: column;\n}\n\n.heading-section h1 {\n  font-size: 42px;\n  font-weight: bold;\n}\n\n.heading-section p {\n  font-size: 16px;\n  margin-top: 15px;\n}\n.top-overlaydem {\n  /* padding: 60px 80px; */\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  background-repeat: no-repeat;\n}\n\n.content-wrapperdem {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0rem;\n}\n\n.mobile-why-container {\n  width: 100vw;\n  overflow: hidden;\n  overflow-x: auto;\n  display: none;\n}\n\n.mobile-why-container-layout {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: 12px;\n}\n\n.mobile-header {\n  height: 120px;\n  width: auto;\n  object-fit: contain;\n}\n\n@media (max-width: 600px) {\n  .why-header {\n    display: none;\n  }\n\n  .mobile-why-container {\n    display: block;\n  }\n}\n\n.heading-textdem {\n  position: relative;\n  top: 0;\n  left: 0;\n  width: 95.5%;\n  height: 90vh;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 2rem;\n  background-image: url('./Assets/LandingPage/LandingPageBg1.jpg');\n  background-size: contain;\n  background-repeat: no-repeat;\n  color: #fff;\n  margin: 0;\n}\n@media (max-width: 600px) {\n  body .heading-textdem {\n    width: 98vw;\n    height: 50vh;\n    background-image: url('./Assets/LandingPage/Topbgmobile.png');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    padding: 0.85rem !important;\n  }\n}\n\n.heading-textgscm {\n  position: relative;\n  top: 0;\n  left: 0;\n  width: 95.5%;\n  height: 90vh;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 2rem;\n  background-image: url('./Assets/LandingPage/Gscmlandingpage.jpg');\n  background-size: contain;\n  background-repeat: no-repeat;\n  color: #fff;\n  margin: 0;\n}\n@media (max-width: 600px) {\n  .heading-textgscm {\n    height: 500px;\n    width: 95.5%;\n    background-image: url('./Assets/LandingPage/Topbggscmmobile.png');\n    padding: 0.85rem !important;\n  }\n}\n\n.otherbtns-container {\n  display: none;\n}\n\n.otherbtns-container-layout {\n  display: flex;\n  flex-direction: column;\n  align-items: end;\n  gap: 8px;\n}\n\n.test-and-webinar-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 2rem;\n  flex-wrap: wrap;\n  padding: 0px 80px 60px 80px;\n  margin-top: -2rem;\n}\n\n.test-section {\n  flex: 1 1 48%;\n}\n\n.enqiry-btn {\n  background: #ffffff;\n  padding: 8px 12px;\n  display: flex;\n  align-items: center;\n  border: none;\n  border-radius: 8px;\n  color: #722c4e;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.reg-btn {\n  background: linear-gradient(270deg, #ffeb42 -495%, #47712b 104.5%);\n  border: 1px solid #edf1ea;\n  box-shadow: 0px 4px 8px 0px #aeaeae40;\n  padding: 8px 12px;\n  color: #edf1ea;\n  font-size: 14px;\n  border-radius: 8px;\n  font-weight: 600;\n  width: 110px;\n}\n\n.form-box {\n  background: #fff5d0;\n  padding: 20px;\n  border-radius: 2px;\n}\n\n.form-box h3 {\n  margin-bottom: 5px;\n}\n\n.form-box p {\n  font-size: 14px;\n  color: #333;\n}\n\n.form-box form input[type='email'],\n.form-box form input[type='text'] {\n  width: 100%;\n  padding: 8px;\n  margin-bottom: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.row {\n  display: flex;\n  gap: 10px;\n}\n\n.checkbox-row,\n.consent-row {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  margin: 10px 0;\n  font-size: 13px;\n}\n\n.captcha-row {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  margin: 10px 0;\n}\n\n.captcha-code {\n  background: #e4e4e4;\n  padding: 8px 15px;\n  border-radius: 5px;\n  font-weight: bold;\n}\n\n.reload-btn {\n  border: none;\n  background: none;\n  font-size: 18px;\n  cursor: pointer;\n}\n\n.register-btn {\n  width: 100%;\n  padding: 10px;\n  background: #79a64a;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  font-weight: bold;\n  margin-top: 10px;\n}\n\n.signin-row {\n  text-align: center;\n  margin-top: 10px;\n  font-size: 14px;\n}\n\n.green-section {\n  background-size: cover;\n  background-position: center;\n  padding: 50px 20px;\n  color: #fff;\n  background-color: #568e46;\n  text-align: center;\n}\n\n.green-section h2 {\n  font-size: 32px;\n  margin-bottom: 15px;\n}\n\n.green-section p {\n  font-size: 18px;\n  margin-bottom: 10px;\n}\n\n.sub-text {\n  font-size: 14px;\n  margin-top: 10px;\n}\n\n.inquiry-container {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.inquiry-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.inquiry-text-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.inquiry-title {\n  color: #061938;\n  font-size: 24px;\n  font-weight: 500;\n  margin: 0;\n}\n\n.inquiry-subtitle {\n  color: #000000;\n  font-size: 12px;\n  font-weight: 400;\n  margin: 0;\n}\n\n.inquiry-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.inquiry-consent {\n  border: 1px solid #ebebeb;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 12px;\n  border-radius: 6px;\n  width: fit-content;\n}\n\n.consent-label {\n  font-size: 12px;\n  font-weight: 400;\n  margin: 0;\n}\n\n.submit-button {\n  background: #47712b;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 600;\n  border: none;\n  padding: 8px 0;\n  width: 100%;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  align-items: start;\n  width: 100%;\n}\n\n.address-field {\n  display: flex;\n  gap: 10px;\n  width: 100%;\n}\n.input-field option[disabled] {\n  color: #999;\n}\n.placeholder-grey {\n  color: #999;\n}\n\n.check-intr {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 10px 0px;\n  width: 100%;\n}\n\n.action-container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  align-items: center;\n  width: 100%;\n}\n\n.input-field {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 14px;\n  background-color: #fcfcfc;\n  box-sizing: border-box;\n  height: 40px;\n  margin-bottom: 6px;\n}\n.scale-150 .input-field {\n  height: 30px;\n}\n.input-field::placeholder {\n  color: #757575 !important;\n  opacity: 1;\n}\n.intr-stu {\n  color: #585a64;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.captcha-conatiner {\n  display: flex;\n  align-items: start;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n  padding-top: 10px;\n}\n\n.register-button {\n  margin-top: 10px;\n  width: 100%;\n  background: linear-gradient(270deg, #ffeb42 -495%, #47712b 104.5%);\n  color: white;\n  padding: 14px;\n  font-size: 16px;\n  font-weight: bold;\n  border: none;\n  /* border-radius: 4px; */\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.scale-150 .register-button {\n  margin-top: 0px;\n  padding: 10px;\n  font-size: 14px;\n}\n.header-heading {\n  font-size: 66px;\n  font-weight: 600;\n  /* text-transform: capitalize !important; */\n  text-align: start;\n  padding-top: 90px;\n  font-family: 'Roboto Serif', serif !important;\n}\n.header-heading-dem {\n  font-size: 46px;\n  font-weight: 600;\n  /* text-transform: capitalize !important; */\n  text-align: start;\n  padding-top: 90px;\n  font-family: 'Roboto Serif', serif !important;\n  width: 100%;\n}\n@media (max-width: 1400px) {\n  .top-overlay {\n    padding: 60px 40px 70px 40px;\n  }\n\n  .header-heading {\n    font-size: 46px;\n    padding-top: 90px;\n    padding-top: 65px !important;\n  }\n}\n@media (min-width: 1900px) {\n  .header-heading {\n    padding-top: 60%;\n  }\n}\n\n.nunito-sans-scope {\n  font-family: 'Nunito', sans-serif;\n}\n\n.nunito-sans-scope * {\n  font-family: 'Nunito', sans-serif;\n}\n\n.roboto-serif {\n  font-family: 'Roboto Serif', serif !important;\n}\n\n.sub-heading {\n  text-align: start !important;\n  font-size: 20px;\n  font-weight: 600;\n  max-width: 50%;\n  font-family: 'Nunito', sans-serif;\n}\n\n.d-flex-space-between {\n  display: flex;\n  /* justify-content: space-between; */\n  align-items: start;\n  /* gap: 30px; */\n  text-align: start;\n  flex-direction: column;\n}\n\n.d-flex-space-between p {\n  font-size: 24px;\n  font-weight: 600;\n  color: #fff;\n}\n\n.d-flex-space-between h6 {\n  font-size: 20px;\n  font-weight: 400;\n  /* font-style: italic; */\n  color: #fff;\n}\n\n.right-form {\n  width: 30%;\n  padding-top: 30px;\n  margin: 100px 0px;\n  background: linear-gradient(rgb(255, 255, 255) 0%, rgb(255, 249, 196) 100%);\n  padding: 35px;\n  box-shadow: rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  text-align: start;\n  box-sizing: border-box;\n}\n\n@media (max-width: 900px) {\n  .right-form {\n    width: 100%;\n    margin: 0px;\n    padding: 20px;\n  }\n  .heading-section {\n    max-width: max-content;\n  }\n}\n\n.right-form-dem {\n  width: 35%;\n  padding-top: 30px;\n  /* margin: 100px 0px; */\n  background: linear-gradient(rgb(255, 255, 255) 0%, rgb(255, 249, 196) 100%);\n  padding: 35px;\n  box-shadow: rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  text-align: start;\n  box-sizing: border-box;\n}\n\n@media (max-width: 900px) {\n  .right-form-dem {\n    width: 100%;\n    margin: 0px;\n    padding: 20px;\n  }\n}\n.right-form1 {\n  width: 45%;\n  margin: 200px 0px;\n  padding-right: 35px;\n  padding-left: 0;\n  display: flex;\n  flex-direction: column;\n  text-align: start;\n}\n\n.font-family-robotoserif {\n  font-family: 'Roboto Serif', serif !important;\n}\n\n.iti {\n  width: 100% !important;\n  margin-bottom: 14px !important;\n}\n\n.d-flex-justify-content-center {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.margin-top-30px {\n  margin-top: 30px;\n}\n\n.programs-container {\n  background-color: #f9f9f9;\n  padding: 0 5% 5%;\n}\n\n.programs-heading {\n  font-size: 38px;\n  font-weight: 700;\n  font-family: 'Roboto Serif', serif !important;\n  color: #585a64;\n}\n\n.programs-list {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n\n.program-card {\n  display: flex;\n  /* background: #fff url(./Assets/LandingPage/programcardbg.png) no-repeat right bottom; */\n  background-size: contain;\n  border-radius: 5px;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  box-shadow:\n    0px 0px 1.41px rgba(0, 0, 0, 0.04),\n    0px 0px 2.81px rgba(0, 0, 0, 0.06),\n    0px 5.62px 11.24px rgba(0, 0, 0, 0.04);\n  border-left: 5px solid transparent;\n  background: white;\n}\n\n.program-content,\n.program-content-testdate {\n  padding: 30px 40px 30px 30px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n    gap: 20px;\n  width: 100%;\n}\n\n.text-cont,\n.card-col-det,\n.card-btn-placement {\n  flex: 1 1;\n  min-width: 240px;\n  display: flex;\n  flex-direction: column;\n  gap: 36px;\n}\n.scale-150 .text-cont,\n.card-col-det,\n.card-btn-placement {\n  flex: 1 1;\n  min-width: 210px;\n  display: flex;\n  flex-direction: column;\n  gap: 36px;\n}\n\n.text-cont {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n.text-cont-testdate {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-top: 28px;\n}\n\n.program-title {\n  color: rgba(114, 44, 78, 1);\n  font-size: 1.75rem;\n  font-weight: 700;\n  font-family: 'Roboto Serif', serif !important;\n}\n.scale-150 .program-title{\n  font-size: 1.5rem;\n}\n\n.scale-150 .program-subtitle{\n  font-size: 0.875rem;\n}\n\n.program-subtitle {\n  font-size: 1rem;\n  color: rgba(114, 44, 78, 1);\n  line-height: 1.5;\n  max-width: 300px;\n  padding-top: 1rem;\n}\n\n.vertical-line {\n  width: 1px;\n  background-color: rgba(229, 230, 234, 1);\n  align-self: stretch;\n}\n\n.card-cont-det {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.programoffer-heading {\n  color: rgba(117, 117, 117, 1);\n  font-size: 1rem;\n  font-weight: 400;\n  margin: 0;\n}\n\n.programoffer-date {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-family: 'Roboto Serif', serif !important;\n  font-size: 1.125rem;\n}\n\n.scale-150 .programoffer-date {\n  font-size: 1rem;\n}\n\n.scale-150 .eligibility-text {\n  font-size: 1rem;\n}\n\n.scale-150 .scholar-text-var2 {\n  font-size: 1rem;\n}\n\n.scale-150 .scholar-text-var1 {\n  font-size: 1.25rem;\n}\n\n.scale-150 .scholar-text-var3 {\n  font-size: 1.25rem;\n}\n.eligibility-text {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #373a45;\n  font-family: 'Roboto Serif', serif !important;\n  margin: 0;\n}\n\n.card-btn-placement {\n  display: flex;\n  justify-content: center;\n  align-items: start;\n}\n\n.brochure-btn {\n  background-color: #3c8031;\n  color: white;\n  padding: 10px 20px;\n  font-weight: 600;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 16px;\n}\n\n.brochure-btn img {\n  width: 16px;\n  height: 16px;\n}\n\n.test-date-ribbon {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: linear-gradient(270deg, #ffeb42 -495%, #47712b 104.5%);\n  color: white;\n  padding: 14px 20px;\n  font-weight: 600;\n  font-size: 15px;\n  clip-path: polygon(0 0, 92% 0, 100% 100%, 91% 100%, 0 100%);\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  font-family: 'Roboto Serif', serif !important;\n}\n\n.test-date-ribbon span {\n  display: inline-block;\n  transform: skew(20deg);\n  font-family: 'Roboto Serif', serif !important;\n}\n\n\n@media (max-width: 600px) {\n  .programs-heading {\n    font-size: 20px;\n    font-weight: 600;\n    margin: 10px 0px;\n  }\n  .header-heading {\n    font-size: 24px;\n    max-width: 100%;\n    padding-top: 65px !important;\n  }\n  .top-overlay {\n    padding: 60px 20px 40px 20px;\n  }\n  .sub-heading {\n    max-width: 80%;\n  }\n  .d-flex-space-between p {\n    font-size: 14px;\n    max-width: 70%;\n  }\n  .d-flex-space-between h6 {\n    font-size: 12px;\n    max-width: 96%;\n    padding: 0px !important;\n    margin: 0px !important;\n  }\n  .d-flex-space-between {\n    display: flex;\n        flex-direction: column;\n        align-items: start;\n        gap: 0px;\n  }\n  .card-cont-det {\n    /* flex-direction: row; */\n    gap: 4px;\n  }\n  .programoffer-date div {\n    font-size: 12px;\n  }\n  .programoffer-heading {\n    font-size: 12px;\n  }\n  .eligibility-text {\n    font-size: 12px;\n  }\n  .card-col-det {\n    gap: 12px;\n    width: 100%;\n  }\n  .program-card {\n    background: #fff;\n  }\n  .program-content {\n    flex-direction: column;\n    align-items: start;\n    padding: 30px 20px;\n  }\n  .vertical-line {\n    display: none;\n  }\n  .text-cont {\n    width: 100%;\n    gap: 8px;\n  }\n  .program-subtitle {\n    width: 100%;\n  }\n  .card-btn-placement {\n    justify-content: 'center';\n    align-items: 'center';\n    width: 100%;\n    margin-top: 24px;\n  }\n  .brochure-btn {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .test-date-ribbon{\n    position: absolute;\n    top: 0;\n    left: 0;\n    background: linear-gradient(270deg, #ffeb42 -495%, #47712b 104.5%);\n    color: white;\n    padding: 14px 0px !important;\n    font-weight: 600;\n    font-size: 15px;\n    clip-path: none !important;\n    z-index: 2;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    font-family: 'Roboto Serif', serif !important;\n    width: 100%;\n  }\n \n}\n\n.recuirters-container {\n  background-color: #f9f9f9;\n}\n\n.spiderConatiner {\n  background:  #f9f9f9;\n  background-position: top;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100%;\n  width: 100%;\n  /* padding: 0px 80px; */\n  box-sizing: border-box;\n}\n\n.scale-150 .spiderConatiner {\n  /* padding: 35px !important; */\n}\n\n.plainbgConatiner {\n  /* background: url(./Assets/LandingPage/Plainbg.png), #f9f9f9; */\n  background-position: top;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100%;\n  width: 100%;\n  padding: 0px 85px 0px 40px;\n  box-sizing: border-box;\n}\n.spiderConatiner1 {\n  background-position: top;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100%;\n  width: 100%;\n  padding: 0px 80px;\n  box-sizing: border-box;\n}\n.webinarContainer {\n  display: grid;\n  grid-template-columns: 4.5fr 7.5fr;\n  column-gap: 100px;\n  align-items: center;\n}\n\n.webinar-content-main {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  align-items: start;\n  width: 100%;\n}\n\n.webinar-header {\n  background: url(./Assets/LandingPage/headerBg.png);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  font-size: 2.25rem;\n  font-weight: 600;\n  color: #373a45;\n  padding: 15px 60px 15px 25px;\n}\n.scale-150 .webinar-header {\n  font-size: 1.75rem ;\n}\n.mobilecard {\n  background: #ffffff;\n  height: 120px;\n  width: 220px;\n  box-shadow: 0px 4px 12px 0px #c1c1c140;\n  gap: 12px;\n  display: none;\n  padding: 12px;\n  box-sizing: border-box;\n}\n\n.card-container-web {\n  display: block;\n}\n\n.mobilecard-main-layout {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: space-between;\n  align-items: start;\n}\n\n.mobilecard-main-layout h6 {\n  color: #373a45;\n  font-size: 12px;\n  font-weight: 700;\n  margin: 0px;\n}\n\n.mobilecard-main-layout p {\n  font-size: 12px;\n  margin: 0px;\n  font-weight: 400;\n  color: #8c8e94;\n}\n\n.mobilecard button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  width: 100%;\n  padding: 6px 0px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #ffffff;\n  background: #47712b;\n}\n\n.webinar-card {\n  box-shadow: 0px 0px 12.2px 0px #f9f9f9;\n  border: 1.23px solid #f1f1f1;\n  background: #fff;\n  border-radius: 10px;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 30px 36px;\n\n\n  \n}\n.webinar-card1 {\n  box-shadow: 0px 0px 12.2px 0px #f9f9f9;\n  /* border: 1.23px solid #f1f1f1; */\n  background: rgba(255, 253, 236, 1);\n  border-radius: 10px;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 30px 36px;\n  border: 15px solid;\n  border-image: linear-gradient(270deg, #FFEB42 -495%, #47712B 104.5%) 1;\n  \n\n  \n}\n\n.webinar-card-grid {\n  display: grid;\n  grid-template-columns: 8fr 4fr;\n  align-items: center;\n}\n\n.webinar-card-grid-II {\n  display: grid;\n  grid-template-columns: 8fr 2fr 2fr;\n  align-items: center;\n  column-gap: 10px;\n}\n\n.webinar-card-header {\n  border-bottom: 1px solid #d3bec8;\n  padding-bottom: 18px;\n}\n\n.webinar-card-content {\n  border-bottom: 1px solid #f1f1f1;\n  padding: 18px 0px;\n}\n\n.webinar-card-grid h6,\n.webinar-card-grid-II h6 {\n  color: #722c4e;\n  font-size: 22px;\n  font-weight: 600;\n  margin: 0px;\n}\n\n.webinar-card-grid h5,\n.webinar-card-grid-II h5 {\n  color: #061938;\n  font-size: 17px;\n  font-weight: 600;\n  margin: 0px;\n}\n\n.webinar-card-grid p,\n.webinar-card-grid-II p {\n  color: #444444;\n  font-size: 14px;\n  font-weight: 400;\n  margin: 0px;\n}\n\n.btn-webinar {\n  background: #49722e;\n  padding: 10px 16px;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  cursor: pointer;\n  text-wrap: nowrap;\n}\n\n.btn-webinar img {\n  height: 16px;\n  width: auto;\n  object-fit: contain;\n}\n\n@media (max-width: 1400px) {\n  .programs-container {\n    padding: 2.1875rem 4.5rem 2.1875rem 3rem;\n  }\n}\n\n.life-vid-container {\n  display: flex;\n  flex-direction: column;\n  width: 95%;\n  margin: 60px 0px;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  box-sizing: border-box;\n}\n\n.life-vid {\n  background: linear-gradient(270deg, #ffeb42 -495%, #47712b 104.5%);\n  text-align: center;\n  padding: 20px 0px;\n  width: 75%;\n}\n\n.life-vid-head {\n  font-size: 21px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0px;\n  text-align: center;\n  font-family: \"Roboto Serif\", serif;\n}\n\n.vid {\n  width: 75%;\n  height: 600px;\n  object-fit: cover;\n}\n\n.scholarship-main-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n}\n\n.scholarship-container {\n  display: flex;\n  flex-direction: column;\n  gap: 47px;\n  width: 68%;\n}\n\n.sclr-header {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  font-family: \"Roboto Serif\", serif;\n}\n\n.sclr-header h6 {\n  color: #585a64;\n  font-size: 48px;\n  font-weight: 600;\n  margin: 0px;\n  font-family: \"Roboto Serif\", serif;\n}\n\n.sclr-header span {\n  font-size: 20px;\n  font-weight: 400;\n  margin: 0px;\n  font-family: \"Roboto Serif\", serif;\n}\n\n.sclr-header p {\n  color: #8c8124;\n  font-size: 24px;\n  font-weight: 500;\n  margin: 0px;\n  font-family: \"Roboto Serif\", serif;\n}\n\n.scholar-grid {\n  display: grid;\n  grid-template-columns: 4fr 4fr 4fr;\n}\n\n.scholar-content {\n  /* height: 300px; */\n  padding: 40px 30px 80px 30px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: end;\n  align-items: start;\n  /* font-family: \"Roboto\", serif; */\n}\n.scale-150 .scholar-content{\n  padding: 2rem;\n}\n.scholar-content-var1 {\n  background: url(./Assets/LandingPage/scholarBg.png);\n  background-position: right;\n  background-repeat: no-repeat;\n  background-size: cover;\n  color: #fff;\n  /* font-family: \"Roboto\", serif; */\n}\n\n.scholar-content-var2 {\n  background: rgba(237, 241, 234, 1);\n  color: #585a64;\n  /* font-family: \"Roboto\", serif; */\n}\n\n.scholar-text-var1 {\n  font-size: 24px;\n  font-weight: 500;\n  margin: 0px;\n  font-family: \"Roboto Serif\", serif;\n}\n\n.scholar-text-var2 {\n  font-size: 21px;\n  font-weight: 600;\n  margin: 0px;\n  font-family: \"Roboto Serif\", serif;\n}\n\n.scholar-text-var3 {\n  font-size: 20px;\n  font-weight: 500;\n  margin: 0px;\n  /* font-family: \"Roboto\", serif; */\n}\n\n.partner-bg {\n  background: url(./Assets/LandingPage/Frame-PartnerUniversities.png);\n  background-repeat: no-repeat;\n  background-position: top;\n  background-size: cover;\n  padding: 0px 80px 30px 110px;\n  display: flex;\n  flex-direction: column;\n  gap: 62px;\n}\n.partner-bg1 {\n  background: url(./Assets/LandingPage/GreenGeomentricline.png);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n  padding: 30px 80px;\n  display: flex;\n  flex-direction: column;\n  gap: 62px;\n}\n\n.partner-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.partner-header {\n  margin: 0px;\n  font-size: 48px;\n  color: #585a64;\n  font-weight: 600;\n}\n\n.location-head {\n  font-size: 36px;\n  color:rgba(71, 113, 43, 1);\n  font-weight: 600;\n  margin: 0px;\n  font-family: \"Roboto Serif\", serif;\n}\n\n.partners-content-container {\n  display: grid;\n  grid-template-columns: 6fr 3fr 3fr;\n  gap: 40px;\n}\n\n.partner-schools-grid {\n  display: grid;\n  grid-template-columns: 6fr 6fr;\n  gap: 12px;\n}\n\n.partner-schools-grid-flex {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.partner-schools-grid-flex-var1 {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  width: 100%;\n}\n\n.partner-school-card {\n  /* box-shadow: 0px 0px 1.58px 0px #0000000a; */\n  /* box-shadow: 0px 0px 3.17px 0px #0000000f; */\n  /* box-shadow: 0px 6.34px 12.68px 0px #0000000a; */\n  /* background: #ffffff; */\n  padding: 18px 26px;\n  height: auto;\n  box-sizing: border-box;\n  width: 100%;\n  /* border: 1px solid rgba(198, 211, 189, 1); */\n}\n\n.partner-school-card-container {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  align-items: start;\n}\n\n.partner-school-card-container img {\n  height: 55px;\n  width: auto;\n  object-fit: contain;\n}\n\n.partner-school-card-container p {\n  font-size: 18px;\n  font-weight: 500;\n  color: #505f79;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.alumni-bg {\n  background: linear-gradient(180deg, rgba(71, 113, 43, 0) 0%, rgba(71, 113, 43, 0.2) 253.83%);\n  padding: 0px 100px 30px 100px;\n  display: flex;\n  flex-direction: column;\n  gap: 60px;\n}\n\n.alumni-header-bg {\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n}\n\n.alumni-header-bg h6 {\n  font-size: 48px;\n  color: #585a64;\n  font-weight: 600;\n  margin: 0px;\n  font-family: \"Roboto Serif\", serif;\n}\n\n.alumni-header-bg p {\n  font-size: 24px;\n  color: #505f79;\n  font-weight: 400;\n  margin: 0px;\n}\n\n.alumni-content-grid {\n  display: grid;\n  grid-template-columns: 6fr 6fr;\n  gap: 60px;\n  align-items: center;\n}\n\n.alumni-content-grid img {\n  height: auto;\n  width: 100%;\n  object-fit: contain;\n}\n\n.countriesname {\n  color: #505f79;\n  font-size: 20px;\n  font-weight: 400;\n  margin: 10px 0px;\n}\n\n@media (max-width: 1300px) {\n  .alumni-content-grid {\n    grid-template-columns: 12fr;\n    align-items: center;\n  }\n  .countriesname {\n    font-size: 20px;\n    font-family: \"Roboto Serif\", serif;\n  }\n}\n\n@media (max-width: 600px) {\n  .countriesname {\n    font-size: 14px;\n    margin: 0px;\n    font-family: \"Roboto Serif\", serif;\n  }\n}\n\n.countries-list {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 8px;\n  line-height: 1.6;\n}\n\n.countriesname {\n  margin: 0;\n  color: #666;\n  font-size: 19px;\n  white-space: nowrap;\n}\n\n.incubation-container-outer {\n  /* background: linear-gradient(270deg, #ffeb42 -495%, #47712b 104.5%); */\n  padding-top: 10px;\n  margin: 80px 100px;\n}\n\n.picture-container-outer {\n  padding-top: 10px;\n  margin: 50px 0px;\n}\n.picture-container {\n  display: grid;\n  grid-template-columns: 5fr 7fr;\n  background: url(./Assets/LandingPage/partnerBg.png);\n  background-position: top;\n  background-repeat: no-repeat;\n  background-size: cover;\n  align-items: center;\n}\n.eligibility-container {\n  display: grid;\n  grid-template-columns: 5fr 7fr;\n  background: url(./Assets/LandingPage/whitelinebg.png);\n  background-position: top;\n  background-repeat: no-repeat;\n  background-size: cover;\n  align-items: center;\n}\n.incubation-container {\n  display: grid;\n  grid-template-columns: 7fr 5fr;\n  background: url(./Assets/LandingPage/partnerBg.png);\n  background-position: top;\n  background-repeat: no-repeat;\n  background-size: cover;\n  align-items: center;\n}\n.placement-container {\n  display: grid;\n  grid-template-columns: 7fr 5fr;\n  background: url(./Assets/LandingPage/Placement-dem.png);\n  background-position: top;\n  background-repeat: no-repeat;\n  background-size: cover;\n  align-items: center;\n}\n.incu-banner {\n  /* height: 580px; */\n  width: 100%;\n  object-fit: cover;\n}\n\n.incu-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding: 0px 100px;\n}\n.picture-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding: 0px 24px 0px 52px;\n}\n\n.incu-layout h6 {\n  color: #585a64;\n  margin: 0px;\n  font-size: 2.857rem;\n  font-weight: 600;\n  font-family: \"Roboto Serif\", serif;\n}\n.scale-150 .incu-layout h6{\n  font-size: 2.25rem;\n}\n.scale-150 .incu-layout p{\n  font-size: 1.25rem;\n}\n.incu-layout p {\n  font-size: 1.5rem;\n  font-weight: 400;\n  color: #505f79;\n  margin: 0px;\n}\n\n.contact-container {\n  background: url(./Assets/LandingPage/contactBg.jpg);\n  margin: 80px 100px;\n  background-position: top;\n  background-repeat: no-repeat;\n  background-size: cover;\n  display: grid;\n  grid-template-columns: 6fr 6fr;\n  align-items: end;\n}\n\n.contact-bg {\n  background: #0000008f;\n  padding: 240px 20px 80px 80px;\n  display: flex;\n  flex-direction: column;\n  gap: 50px;\n  box-sizing: border-box;\n}\n\n.contact-cell-container {\n  display: flex;\n  align-items: center;\n  gap: 2.5rem;\n}\n\n.contact-cell-container img {\n  border-radius: 50px;\n  height: 46px;\n  width: 46px;\n  object-fit: contain;\n  padding: 1.25rem;\n  background: #fffdec;\n}\n\n.contact-dets-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.contact-dets-container h6 {\n  color: #ffffff;\n  font-size: 1.5rem;\n  font-weight: 400;\n  margin: 0px;\n}\n.scale-150 .contact-dets-container h6 {\n  font-size: 1.25rem ;\n}\n.scale-150 .contact-dets-container h5 {\n  font-size: 1.5rem;\n}\n.contact-dets-container h5 {\n  color: #ffffff;\n  font-size: 1.75rem;\n  font-weight: 700;\n  margin: 0px;\n  font-family: \"Roboto\", serif;\n}\n\n.contact-banner-cont {\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  gap: 0.75rem;\n  padding: 0rem 1.25rem 3.75rem 5rem;\n}\n.scale-150 .contact-banner-cont h6 {\n  font-size: 2.25rem;\n}\n.scale-150 .contact-banner-cont p {\n  font-size: 1.25rem;\n}\n.scale-150 .contact-banner-cont {\n  padding: 0rem 1.25rem 3.75rem 2.5rem;\n}\n\n.contact-banner-cont p {\n  color: #ffffff;\n  font-size: 1.375rem;\n  font-weight: 500;\n  margin: 0px;\n}\n\n.contact-banner-cont h6 {\n  color: #ffffff;\n  font-size: 2.8125rem;\n  font-weight: 600;\n  margin: 0px;\n  font-family: \"Roboto\", serif;\n}\n\n.footer-container {\n  background: url(./Assets/LandingPage/partnerBg.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: top;\n  padding-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.footer-container img {\n  height: 72px;\n  width: auto;\n  object-fit: contain;\n  margin-top: 50px;\n}\n\n.show-banner {\n  display: none;\n}\n\n.incu-banner-lan {\n  object-fit: contain;\n  width: 100%;\n}\n\n@media (max-width: 1400px) {\n  .webinarContainer {\n    grid-template-columns: 12fr;\n    column-gap: 0px;\n  }\n  .spiderConatiner {\n    /* padding: 0px 60px 0px 60px; */\n  }\n}\n\n@media (max-width: 600px) {\n  .spiderConatiner {\n    padding: 0px !important;\n  }\n  .programs-container {\n    padding: 0px 20px 30px;\n  }\n  .webinar-card-content {\n    display: none;\n  }\n  .webinar-card-header {\n    display: none;\n  }\n  .webinar-card {\n    background: none;\n    padding: 0px;\n    display: flex;\n    align-items: start;\n  }\n  .spiderConatiner {\n    /* padding: 0px 20px; */\n  }\n  .life-vid {\n    width: 100%;\n    padding: 5px 0px;\n  }\n  .vid {\n    width: 100%;\n    height: 30%;\n  }\n  .life-vid-head {\n    font-size: 12px;\n  }\n  .scholar-grid {\n    grid-template-columns: 12fr;\n  }\n  .scholarship-container {\n    width: 100%;\n  }\n  .scholar-text-var2 {\n    font-size: 16px;\n  }\n  .scholar-text-var3 {\n    font-size: 18px;\n  }\n  .scholar-text-var1 {\n    font-size: 18px !important;    \n  }\n  .scholar-content {\n    padding: 30px 20px;\n    height: fit-content !important;\n        justify-content: start;\n  }\n  .alumni-bg {\n    padding: 20px;\n  }\n  .incubation-container {\n    grid-template-columns: 12fr;\n  }\n  .eligibility-container {\n    grid-template-columns: 12fr;\n  }\n  .show-banner {\n    display: block !important;\n  }\n  .incubation-container-outer {\n    margin: 80px 20px;\n  }\n  .incu-banner {\n    display: none;\n  }\n  .incu-banner-lan {\n    display: none;\n    /* height: 250px; */\n  }\n  .incu-banner-lan {\n    display: none;\n    /* height: 250px; */\n  }\n  .picture-container-outer {\n    margin: 80px 20px;\n  }\n  .picture-layout {\n    padding: 16px;\n  }\n  .incu-layout {\n    padding: 16px;\n  }\n  .contact-container {\n    margin: 80px 20px;\n    grid-template-columns: 12fr;\n  }\n  .contact-dets-container h6 {\n    font-size: 12px;\n  }\n  .contact-dets-container h5 {\n    font-size: 15px;\n  }\n  .contact-cell-container img {\n    height: 26px;\n    padding: 12px;\n    width: 26px;\n  }\n  .contact-banner-cont {\n    padding: 120px 0px 40px 20px;\n  }\n  .contact-bg {\n    gap: 20px;\n    padding: 40px 8px;\n  }\n  .contact-banner-cont p {\n    font-size: 12px;\n  }\n  .contact-banner-cont h6 {\n    font-size: 24px;\n    font-family: \"Roboto\", serif;\n  }\n  .partner-bg {\n    padding: 20px;\n  }\n  .partner-container {\n    gap: 12px;\n    overflow: hidden;\n    overflow-x: auto;\n  }\n  .partner-container::-webkit-scrollbar {\n    display: none;\n  }\n  .partner-schools-grid {\n    display: flex;\n    gap: 12px;\n    flex-direction: column;\n  }\n  .partner-schools-grid-flex {\n    flex-direction: column;\n    gap: 20px;\n  }\n  .partner-schools-grid-flex-var1 {\n    gap: 16px;\n  }\n  .partners-content-container {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n  .location-head {\n    font-size: 20px;\n    font-family: \"Roboto Serif\", serif;\n    color:'rgba(71, 113, 43, 1)'\n  }\n  .partner-school-card {\n    height: auto;\n    padding: 10px 16px !important;\n  }\n  .partner-school-card-container p {\n    text-wrap: nowrap;\n  }\n  .webinar-content-main {\n    gap: 8px;\n  }\n  .webinar-header {\n    font-size: 24px;\n    font-weight: 500;\n  }\n  .webinarContainer {\n    row-gap: 24px;\n  }\n  .sclr-header h6 {\n    font-size: 20px;\n  }\n  .sclr-header span {\n    font-size: 10px;\n  }\n  .sclr-header p {\n    font-size: 14px;\n  }\n  .sclr-header {\n    gap: 12px;\n  }\n  .partner-bg {\n    gap: 24px;\n    padding-top: 0px;\n    background: #ffffff;\n  }\n  .alumni-header-bg h6 {\n    font-size: 20px;\n    font-family: \"Roboto Serif\", serif;\n  }\n  .alumni-header-bg p {\n    font-size: 14px;\n  }\n  .alumni-bg {\n    gap: 16px;\n    background: #fff;\n  }\n  .incu-layout h6 {\n    font-size: 20px;\n    font-family: \"Roboto Serif\", serif;\n  }\n  .incu-layout p {\n    font-size: 14px;\n  }\n  .incu-layout {\n    gap: 12px;\n  }\n  .incubation-container-outer {\n    margin: 20px;\n  }\n  .full-width-scroll {\n    width: 100vw;\n    overflow: scroll;\n  }\n  .card-container-web {\n    display: flex;\n    align-items: start;\n    width: max-content;\n    gap: 12px;\n  }\n  .mobilecard {\n    display: flex;\n    flex-direction: column;\n  }\n  .otherbtns-container {\n    display: flex;\n    align-items: start;\n    justify-content: space-between;\n  }\n}\n\n.appprocess-container {\n  width: 100%;\n  height: 100%;\n  background: url('./Assets/LandingPage/ApplicationProcess.png') no-repeat center center;\n  background-size: cover;\n}\n@media (max-width: 768px) {\n  .appprocess-container {\n    background: url('./Assets/LandingPage/ApplicationProcessmobilebg.png') no-repeat center center;\n    background-size: cover;\n  }\n}\n.appprocess-overlay {\n  display: flex;\n  width: 100%;\n  min-height: 400px;\n}\n\n.appprocess-left,\n.appprocess-right {\n  flex: 1;\n}\n\n.appprocess-left {\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  padding: 40px;\n  padding-bottom: 20px;\n}\n\n.appprocess-heading {\n  font-size: 32px;\n  font-weight: bold;\n  color: white;\n  font-family: 'Roboto Serif', serif !important;\n}\n\n.appprocess-right {\n  background-color: rgba(0, 0, 0, 0.56);\n  display: flex;\n  /* align-items: center; */\n}\n\n.appprocess-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 40px;\n  color: white;\n}\n\n.step {\n  display: flex;\n  align-items: center;\n  font-size: 22px;\n  font-family: 'Roboto Serif', serif !important;\n}\n\n.step-icon {\n  color: #3ad447;\n  font-size: 24px;\n  margin-right: 10px;\n}\n\n.address {\n  font-size: 1rem;\n  color: #47712b;\n  font-weight: 400;\n  max-width: 20.75rem;\n  margin: 2.75rem 0rem 2.5rem 0rem;  \n  text-align: center;\n}\n\n.scale-150 .address {\n  font-size: 1rem;\n  max-width: 21.875rem;\n  margin: 2.1875rem 0;  \n}\n\n.divider {\n  height: 1.4px;\n  background: #5a4a95;\n  width: 85%;\n}\n\n.about-program-container {\n  /* max-width: 1200px;\n  margin: 0 auto; */\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2rem;\n  align-items: center;\n  /* justify-content: space-between; */\n  justify-content: space-around;\n}\n\n.about-program-text {\n  flex: 1;\n  min-width: 300px;\n  color: white;\n}\n\n.about-title {\n  font-size: 3.5rem;\n  margin-bottom: 2.5rem;\n  color: white;\n}\n.scale-150 .about-title{\n  font-size: 3rem;\n  margin-bottom: 2rem;\n}\n.scale-150 .content{\n  font-size: 1rem;\n}\n.scale-150 .content-dem{\n  font-size: 1.5rem;\n}\n.scale-150 .bullet{\n  font-size: 0.75rem;\n}\n.about-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  color: white;\n}\n\n.about-item {\n  display: flex;\n  align-items: first baseline;\n  margin-bottom: 1rem;\n  color: white;\n}\n\n.bullet {\n  font-weight: bold;\n  margin-right: 10px;\n  line-height: 1;\n  font-size: 1rem;\n}\n\n.content {\n  font-size: 1.25rem;\n  line-height: 1.5;\n}\n.content-dem{\n  font-size: 2rem;\n  line-height: 1.5;\n}\n.about-program-image-wrapper {\n  flex: 1;\n  min-width: 300px;\n  display: flex;\n  justify-content: center;\n}\n\n.about-program-image-card {\n  transform: translateY(50px);\n}\n\n.about-program-image-card img {\n  width: 100%;\n  height: auto;\n}\n.about-program-image-wrapper {\n  flex: 1;\n  min-width: 300px;\n  display: flex;\n  justify-content: center;\n  position: relative;\n}\n.about-program-image-card .main-image {\n  width: 80%;\n  height: 90%;\n  border-radius: 6px;\n  display: block;\n}\n\n.about-program-image-card .overlay-image {\n  position: absolute;\n  bottom: 10%;\n  left: 30%;\n  transform: translateX(-50%);\n  width: 100%;\n}\n\n.containerprogram {\n  display: flex;\n  width: 100%;\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n  align-items: center;\n}\n\n.left img {\n  max-width: 100%;\n  height: auto;\n  display: block;\n}\n\n.right {\n  padding-left: 2rem;\n}\n\n.key-elements-container {\n  /* padding: 3rem 0rem; */\n  text-align: center;\n  background: linear-gradient(to right, #f9f9f9 85%, transparent 50%);\n}\n\n.key-elements-heading {\n  font-size: 2rem;\n  color: #444;\n  margin-bottom: 2rem;\n}\n\n.key-elements-grid {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n}\n@media (max-width: 768px) {\n  .key-elements-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.key-element-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem 1rem;\n  text-align: center;\n  min-height: 160px;\n  position: relative;\n}\n\n.key-element-card:not(:nth-child(6n))::after {\n  content: '';\n  position: absolute;\n  top: 15%;\n  right: 0;\n  height: 70%;\n  width: 1px;\n  background: linear-gradient(to bottom, rgba(63, 107, 63, 0.1), rgba(63, 107, 63, 0.5));\n}\n\n.key-element-card:not(:nth-last-child(-n + 6))::before {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 15%;\n  width: 70%;\n  height: 1px;\n  background: linear-gradient(to right, rgba(63, 107, 63, 0.1), rgba(63, 107, 63, 0.5));\n}\n\n.key-element-card:nth-last-child(-n + 6) {\n  border-bottom: 2px solid #3f6b3f;\n}\n\n.key-element-icon {\n  width: 50px;\n  height: 50px;\n  margin-bottom: 0.8rem;\n}\n\n.key-element-title {\n  font-size: 20px;\n  color: #333;\n  max-width: 230px;\n}\n.program-structure {\n  padding: 0rem 5.5rem 0rem 2rem;\n  text-align: center;\n}\n\n.heading {\n  font-size: 2.5rem;\n  font-weight: 600;\n  color: #2d2d2d;\n  margin-bottom: 2.5rem;\n}\n\n.cards-row {\n  display: flex;\n  justify-content: center;\n  flex-wrap: nowrap;\n  /* overflow-x: auto; */\n}\n\n.card {\n  flex: 1;\n  min-width: 200px;\n  max-width: 285px;\n  padding: 1.5rem;\n  text-align: left;\n  box-sizing: border-box;\n}\n\n.card-green {\n  background-color: #f1f5f0;\n}\n\n.card-white {\n  background-color: #ffffff;\n}\n\n.card-border {\n  position: relative;\n}\n\n.card-border::after {\n  content: '';\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 2px;\n  height: 30px;\n  background-color: #6e5ba4;\n}\n\n.card-number {\n  font-weight: 500;\n  font-size: 1rem;\n  color: rgba(88, 90, 100, 1);\n  margin-bottom: 0.4rem;\n  display: inline-block;\n}\n\n.card-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  margin-bottom: 0.4rem;\n  color: rgba(42, 42, 42, 1);\n\n}\n\n.card-description {\n  font-size: 1rem;\n  color: rgba(80, 95, 121, 1);\n  font-family: 'Nunito' !important;\n}\n\n.placement-heading {\n  font-size: 2.5rem;\n  color: rgba(88, 90, 100, 1);\n  font-weight: 600;\n  margin-bottom: 2.5rem;\n}\n\n.placement-section {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.placement-custom-grid {\n  display: flex;\n  gap: 2rem;\n  justify-content: center;\n  flex-wrap: wrap;\n  max-width: 1200px;\n  width: 100%;\n}\n\n/* .placement-box {\n  padding: 1.5rem;\n  color: #2d2d2d;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 160px;\n} */\n\n.placement-box h3 {\n  margin: 0;\n  font-size: 1.2rem;\n}\n\n.placement-box .big {\n  font-size: 1.6rem;\n  font-weight: bold;\n  /* color: #0a5f30; */\n}\n\n.placement-box p {\n  font-size: 0.9rem;\n  margin-top: 0.5rem;\n  \n}\n\n.green {\n  background-color: #3f6b3f;\n  color: #fff;\n}\n\n.yellow {\n  background-color: #fff7ba;\n  color: rgba(71, 113, 43, 1);\n}\n\n.lightgray {\n  background-color: #f0f0f0;\n  color: rgba(71, 113, 43, 1);\n}\n\n.image-box {\n  height: 100%;\n  overflow: hidden;\n}\n\n.image-box img {\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.placement-custom-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  /* padding: 0rem 4rem; */\n}\n\n.column {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  max-width: 300px;\n  gap: 1rem;\n  height: 400px;\n}\n\n.placement-box {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  /* padding-top: 5rem; */\n}\n\n.full-width {\n  width: 100%;\n}\n.alumni-header-row1 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 2rem;\n}\n\n.alumni-header-row1 h6 {\n  flex: 1;\n  font-size: 1.5rem;\n  margin: 0;\n}\n\n.alumni-header-row1 p {\n  flex: 3;\n  text-align: right;\n  margin: 0;\n}\n.key-elements-container-gscm {\n  /* padding: 3rem 2rem; */\n  text-align: center;\n  background: linear-gradient(to right, #f9f9f9 95%, transparent 50%);\n}\n\n.key-elements-grid-gscm {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n}\n\n.key-element-card-gscm {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  min-height: 160px;\n  position: relative;\n}\n\n.key-element-card-gscm:not(:nth-child(4n))::after {\n  content: '';\n  position: absolute;\n  top: 15%;\n  right: 0;\n  height: 70%;\n  width: 1px;\n  background: linear-gradient(to bottom, rgba(63, 107, 63, 0.1), rgba(63, 107, 63, 0.5));\n}\n\n.key-element-card-gscm:not(:nth-last-child(-n + 4))::before {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 15%;\n  width: 70%;\n  height: 1px;\n  background: linear-gradient(to right, rgba(63, 107, 63, 0.1), rgba(63, 107, 63, 0.5));\n}\n\n.key-element-card-gscm:nth-last-child(-n + 4) {\n  border-bottom: 2px solid #3f6b3f;\n}\n\n.webinar-mobile-scroll {\n  display: none;\n}\n\n@media screen and (max-width: 768px) {\n  .webinar-mobile-scroll {\n    display: flex;\n    overflow-x: auto;\n    gap: 1rem;\n    padding: 1rem 0;\n    scroll-snap-type: x mandatory;\n  }\n\n  .webinar-mobile-card {\n    min-width: 80%;\n    flex: 0 0 auto;\n    background-color: white;\n    border-radius: 8px;\n    padding: 1.5rem;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n    scroll-snap-align: start;\n  }\n\n  .program-title {\n    font-weight: 700;\n    font-size: 1.2rem;\n    margin-bottom: 0.5rem;\n    color: rgba(114, 44, 78, 1) !important;\n    \n  }\n\n  .date-label {\n    color: #999;\n    margin-bottom: 1rem;\n  }\n\n  .date-value {\n    color: #f46f5e;\n    font-weight: 600;\n  }\n\n  .register-btn {\n    background-color: #476d24;\n    color: white;\n    padding: 0.75rem 1.5rem;\n    border: none;\n    border-radius: 4px;\n    font-size: 1rem;\n    cursor: pointer;\n  }\n\n  .webinar-desktop-card {\n    display: none;\n  }\n  .appprocess-steps {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding: 1rem;\n    color: white;\n  }\n  .address {\n    font-size: 14px;\n    color: #47712b;\n    font-weight: 400;\n    max-width: 300px;\n    margin: 60px 0px 40px 0px;\n    text-align: center;\n  }\n  \n}\n\n/* CustomDatePicker.css */\n/* .react-datepicker {\n  border: none;\n  font-family: 'Nunito Sans', sans-serif;\n  padding: 1rem;\n  width: 100%;\n  max-width: 300px;\n} */\n\n.react-datepicker__header {\n  background: none !important;\n  border-bottom: none !important;\n  padding-bottom: 0.5rem;\n}\n\n.react-datepicker__current-month {\n  font-weight: 600;\n  font-size: 1rem;\n  color: #2e2e2e;\n}\n\n.react-datepicker__day-names {\n  margin-top: 0.5rem;\n  display: flex;\n  justify-content: space-between;\n  font-weight: 500;\n  color: #777;\n}\n\n.react-datepicker__week {\n  display: flex;\n  justify-content: space-between;\n  margin: 0.2rem 0;\n}\n\n.react-datepicker__day {\n  border-radius: 6px;\n  width: 36px;\n  height: 36px;\n  line-height: 36px;\n  text-align: center;\n  margin: 0;\n  cursor: pointer;\n  font-weight: 500;\n  color: #2e2e2e;\n}\n\n.react-datepicker__day--selected,\n.react-datepicker__day--keyboard-selected {\n  background-color: #4b8a2e;\n  color: white;\n}\n\n.react-datepicker__day--disabled {\n  color: #ccc;\n  cursor: not-allowed;\n}\n\n.react-datepicker__triangle {\n  display: none;\n}\n\n/* Green for allowed dates */\n.allowed-green-day {\n  background-color: #d4edda !important;\n  color: #256029 !important;\n  border-radius: 6px;\n}\n\n/* Red for selected date */\n.selected-red-day {\n  background-color: #f8d7da !important;\n  color: #721c24 !important;\n  border-radius: 6px;\n}\n\n.custom-checkbox {\n  position: relative;\n  appearance: none;\n  width: 16px;\n  height: 16px;\n  border: 2px solid #ccc;\n  border-radius: 3px;\n  cursor: pointer;\n}\n\n.custom-checkbox:checked {\n  background-color: rgba(181, 167, 47, 1);\n  border-color: rgba(181, 167, 47, 1);\n}\n\n.custom-checkbox:checked::after {\n  content: '✔';\n  position: absolute;\n  top: -1px;\n  left: 1px;\n  color: white;\n  font-size: 12px;\n}\n\n/* Make the datepicker calendar full width */\n.react-datepicker {\n  padding: 10px 15px;\n  width: 100% !important;\n  border: none !important;\n  border-radius: 10px !important;\n  box-shadow: 0px 0px 15px 0px rgba(96, 71, 151, 0.1);\n  height: 100% !important;\n  width: 95% !important;\n}\n\n/* Optional: make the month grid full width */\n.react-datepicker__month-container {\n  width: 100%;\n}\n\n/* Optional: adjust day cell sizing if you want better spacing */\n.react-datepicker__day {\n  width: 100% !important;\n  max-width: 100%;\n  text-align: center;\n}\n\n/* Hide dates from other months */\n.hide-outside-dates {\n  visibility: hidden;\n  pointer-events: none;\n}\n\n/* Keep your custom styles */\n.custom-allowed-day {\n  background-color: rgba(237, 241, 234, 1) !important;\n  color: #000;\n  border-radius: 6px;\n}\n\n.custom-today-day {\n  background-color: rgba(237, 241, 234, 1) !important;\n  border: 1px solid rgba(108, 141, 85, 1) !important;\n  color: #000;\n  border-radius: 6px;\n}\n\n.custom-selected-day {\n  background: linear-gradient(270deg, #ffeb42 -495%, #47712b 104.5%) !important;\n  color: white !important;\n  border-radius: 6px;\n}\n\n.webinar-banner {\n  margin-bottom: 70px;\n  background-size: cover;\n  background-position: center;\n  width: 100%;\n  min-height: 433px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  padding: 40px 20px;\n  position: relative;\n}\n\n.webinar-content {\n  padding-left: 22%;\n  max-width: 600px;\n  width: 100%;\n  border-radius: 8px;\n\n}\n.scale-150 .webinar-content{\n  padding-left: 30%;\n}\n\n.webinar-label {\n  color: #47712b;\n  font-weight: bold;\n  font-size: 1.1rem;\n  margin-bottom: 10px;\n}\n\n.webinar-title {\n  font-size: 3rem;\n  font-weight: 700;\n  color: #1b1b1b;\n  margin: 5px 0;\n}\n.scale-150 .webinar-title{\n  font-size: 2.25rem;\n}\n.scale-150 .webinar-subtext {\n  font-size: 1rem !important;\n  margin-top: 0;\n}\n.webinar-subtext {\n  border-radius: 6px;\n  /* padding: 6px 14px; */\n  margin-top: 30px;\n  font-style: italic;\n  font-size: 1.1rem;\n  color: #333;\n  display: flex;\n  align-items: center;\n  /* background-color: rgba(237, 241, 234, 1); */\n  max-width: 100%;\n  width: fit-content;\n  font-family: 'Nunito, sans-serif';\n}\n\n.dot-icon {\n  color: #c53030;\n  font-weight: bold;\n  margin-right: 8px;\n  font-size: 18px;\n}\n\n/* ✅ Responsive Breakpoints */\n@media screen and (max-width: 768px) {\n  .webinar-content {\n    padding-left: 0;\n    text-align: center;\n    display: flex;\n        flex-direction: column;\n        align-items: center;\n  }\n\n  .webinar-title {\n    font-size: 32px;\n  }\n\n  .webinar-subtext {\n    justify-content: center;\n    font-size: 0.95rem;\n    padding: 0px !important;\n\n  }\n\n  .dot-icon {\n    font-size: 16px;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .webinar-title {\n    font-size: 24px;\n  }\n\n  .webinar-label {\n    font-size: 1rem;\n  }\n\n  .webinar-subtext {\n    font-size: 0.9rem;\n    /* width: 100% !important; */\n    margin-top: 0px !important;\n\n  }\n}\n.slider-list {\n  height: 100% !important;\n}\n\n.slider-container {\n  height: 100% !important;\n}\n.input-error {\n  border-color: red;\n}\n\n.error-text {\n  color: red;\n  font-size: 13.5px;\n  margin-bottom: 4px;\n}\nselect.select-custom:disabled {\n  background-color: #f5f5f5 !important;\n  opacity: unset !important;\n  border: 1px solid #ccc;\n  cursor: unset !important;\n}\n/* CSS */\n.select-custom {\n  appearance: none;\n  -webkit-appearance: none; /* Safari */\n  -moz-appearance: none; /* Firefox */\n  background-color: #fcfcfc;\n  background-image: url('data:image/svg+xml;utf8,<svg fill=\"rgba(116,116,116,1)\" height=\"30\" viewBox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 10l5 5 5-5z\"/></svg>');\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  background-size: 16px;\n  color: rgba(116, 116, 116, 1);\n  border: 1px solid #ccc;\n  height: 40px;\n  border-radius: 6px;\n  width: 100%;\n  padding: 0px 12px;\n  margin-bottom: 4.5px;\n  cursor: pointer !important;\n}\n.scale-150 .select-custom {\n  height: 30px;\n}\n.program-select-custom{\n  appearance: none;\n  -webkit-appearance: none; /* Safari */\n  -moz-appearance: none; /* Firefox */\n  background-color: #fcfcfc;\n  background-image: url('data:image/svg+xml;utf8,<svg fill=\"rgba(116,116,116,1)\" height=\"30\" viewBox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 10l5 5 5-5z\"/></svg>');\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  background-size: 16px;\n  color: rgba(116, 116, 116, 1);\n  border: 1px solid #ccc;\n  height: 40px;\n  border-radius: 6px;\n  width: 100%;\n  padding: 0px 12px;\n  margin-bottom: 4.5px;\n  cursor: pointer !important;\n}\nselect.program-select-custom:disabled {\n  background-color: #f5f5f5 !important;\n  opacity: unset !important;\n  border: 1px solid #ccc;\n  cursor: unset !important;\n}\n.scale-150 .program-select-custom {\n  height: 30px;\n}\n\n.alumni-wrapper {\n  padding: 3.5rem;\n  overflow: hidden;\n  padding-bottom: 0;\n}\n\n.alumni-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.alumni-header h2 {\n  font-size: 24px;\n  font-weight: bold;\n  font-family: 'Roboto', sans-serif;\n  background: linear-gradient(90deg, #fffbcf, transparent);\n  padding: 0.5rem 1rem;\n}\n\n.arrow-buttons button {\n  margin-left: 8px;\n  padding: 0px 13px;\n  font-size: 31px;\n  border: none;\n  background-color: rgba(255, 249, 196, 1);\n  cursor: pointer;\n  color: rgba(107, 99, 28, 1);\n}\n\n.image-row {\n  display: flex;\n  gap: 2rem;\n  margin-top: 1.5rem;\n  height: 600px;\n}\n\n.image-sixty {\n  width: 60%;\n  height: 70%;\n  object-fit: cover;\n}\n\n.image-forty {\n  width: 40%;\n  height: 70%;\n  object-fit: cover;\n}\n\n\n\n@media (max-width: 768px) {\n  .image-row {\n    flex-direction: column;\n    height: auto;\n  }\n\n  .image-sixty,\n  .image-forty {\n    width: 100%;\n    height: 300px;\n  }\n}\n\n\n/* Tablet screens (≤ 992px) and smaller */\n@media screen and (max-width: 992px) {\n  .partners-content-container {\n    grid-template-columns: 1fr; \n    gap: 24px; \n  }\n}\n\n.card {\n  transition: transform 0.1s ease;\n  transform: scale(1.05);\n  cursor: pointer;\n  text-align: left;\n}\n\n.card:hover {\n  transform: scale(1.03);\n  background-color: rgba(198, 211, 189, 1);\n}\n\n.card-title,\n.card-description {\n  transition: font-size 0.1s ease;\n}\n\n.card:hover .card-title {\n  font-size: 24px; /* 4px increase from default (e.g. 20px) */\n}\n\n.card:hover .card-description {\n  font-size: 18px; /* 4px increase from default (e.g. 14px) */\n}\n\n.zoomed-out {\n  font-size: 33.33%; /* all rem units inside will be scaled to 1/3 */\n}\n\n.duration-badge {\n  background-color: #f2f6f1;\n  color: #2c5e1a;\n  font-weight: 600;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 14px;\n}\n\n.overlay-video {\n  width: 100%;\n  height: 100%;\n  border-radius: 12px;\n  object-fit: cover;\n}\n/* @media (min-resolution: 1.5dppx) {\n  .form-wrapper {\n    transform: scale(0.75);\n    transform-origin: top right;\n  }\n\n  .form-wrapper-container {\n    overflow: visible;\n    width: fit-content;\n  }\n} */\n@media (min-resolution: 1.2dppx) {\n  .form-wrapper {\n    transform: scale(0.85);\n    transform-origin: top right;\n  }\n\n  .form-wrapper-container {\n    overflow: visible;\n    width: fit-content;\n  }\n}\n\n\n@media (min-resolution: 1.79dppx) {\n  .form-wrapper {\n    transform: scale(1);\n    transform-origin: unset;\n  }\n\n  .form-wrapper-container {\n    width: 450px;\n  }\n}\n.form-wrapper{\n  font-family: 'Nunito', sans-serif;\n}\n\n@media (min-resolution: 1.2dppx) {\n  .floating-panel {\n    transform: scale(0.75);\n    transform-origin: top right;\n  }\n}\n\n.custom-textarea::placeholder {\n  font-family: 'Nunito', sans-serif;\n}\n\n@media (min-resolution: 1.2dppx) {\n  .application-card-wrapper {\n    transform: scale(0.95);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
